<template>
  <div class="relative">
    <!-- Loader -->
    <portal to="loaderTarget">
      <div
        class="absolute bg-grey-100 bg-opacity-50 h-full left-0 top-0 w-full z-99"
        v-if="isLoading"
      >
        <gd-loader :label="$t('frontend_loading')" />
      </div>
    </portal>

    <div class="dock bg-secondary-darker text-secondary-invert" id="dock"></div>

    <div class="editor relative" @mousewheel="onMouseWheelChange($event)">
      <div
        class="node-editor w-full"
        id="rete"
        ref="rete"
        v-bind:class="this.model.viewtype"
      ></div>
      <gd-button
        size="icon"
        @click="changeview('vertical')"
        class="absolute vertical-btn"
      >
        <VerticalLayoutIcon class="h-4 w-4 vertical-layout-icon" />
      </gd-button>
      <gd-button
        size="icon"
        @click="changeview('horizontal')"
        class="mr-1 absolute horizontal-btn"
      >
        <VerticalLayoutIcon class="h-4 w-4 horizontal-layout-icon" />
      </gd-button>

      <gd-button
        size="icon"
        class="absolute zoom-in-btn-editor"
        :disabled="zoomInDisabled"
        @click="zoomIn(0.05)"
      >
        <PlusIcon class="h-5 w-5" />
      </gd-button>
      <gd-button
        size="icon"
        class="mr-1 absolute zoom-out-btn-editor"
        :disabled="zoomOutDisabled"
        @click="zoomOut(-0.05)"
      >
        <MinusIcon class="h-5 w-5" />
      </gd-button>
    </div>

    <ConfigMenu
      ref="configMenu"
      :class="{
        'configuration-tab':
          this.$refs && this.$refs.configMenu && this.$refs.configMenu.show,
        'configuration-tab-hidden':
          this.$refs && this.$refs.configMenu && !this.$refs.configMenu.show
      }"
      @saveTagTrigger="savetag"
      @saveListTrigger="savelist"
      @updateEdittedModuleData="updatemoduledetail"
      @saveRuleTrigger="saverule"
      @saveEmailTrigger="saveemaildetail"
      @saveSmsTrigger="savesmsdetail"
      @saveDelayTrigger="savedelaydetail"
      @saveSplitTrigger="savesplitdetail"
      @saveGotoTrigger="savegotodetail"
      @zoomIn="zoomIn"
      @zoomOut="zoomOut"
      @sideMenuClosed="configurationMenuClosed"
      :model="model"
      @updateModel="model = $event"
      @createNewList="openCreateListModal"
      @createNewTag="openCreateTagModal"
      @createNewSmsSender="openCreateSmsSenderModal"
      @createNewEmailSender="openCreateEmailSenderModal"
      @saveOnEmailContentReset="saveOnEmailContentReset"
      @showLoader="showLoader"
      @hideLoader="hideLoader"
      @savePostalTrigger="savePostalTrigger"
    ></ConfigMenu>

    <gd-modal
      name="create-maillist-in-sequence-modal"
      :title="$t('frontend_groovemail_contacts_step4_create_new_list')"
    >
      <create-list
        :type="'add'"
        :mail_list_id="null"
        :mail_list_data="mail_list_data"
        @showLoader="showLoader"
        @hideLoader="hideLoader"
        @fetchEventsList="fetchEventsList"
        @closeCreateMaillistModal="closeCreateMaillist"
      >
      </create-list>
    </gd-modal>

    <gd-modal
      name="create-mailtag-in-sequence-modal"
      :title="$t('frontend_groovemail_contacts_step4_create_newtag')"
    >
      <create-tag
        :type="'add'"
        :mail_tag_id="null"
        :mail_tag_data="mail_tag_data"
        @showLoader="showLoader"
        @hideLoader="hideLoader"
        @fetchTags="fetchEventsTags"
        @closeCreateTagsModal="closeCreateMailtag"
      ></create-tag>
    </gd-modal>

    <gd-modal
      id="create-email-sender-wrapper"
      name="create-email-sender-in-sequence-modal"
      :title="$t('frontend_groovemail_settings_sender_settings')"
    >
      <VuePerfectScrollbar>
        <div class="scroll-modal-tab">
          <create-email-sender
            ref="createEmailSender"
            @emailSenderCreated="emailSenderCreated"
          >
          </create-email-sender>
          <div class="flex justify-end p-6 pt-0">
            <gd-button size="auto" @click="closeCreateEmailSenderModal">{{
              $t('frontend_cancel')
            }}</gd-button>
            <gd-button
              variant="primary"
              size="auto"
              class="ml-2"
              @click="createNewEmailSender"
            >
              {{ $t('frontend_groovemail_create_sender_route_page_title') }}
            </gd-button>
          </div>
        </div>
      </VuePerfectScrollbar>
    </gd-modal>

    <gd-modal
      id="create-sms-sender-wrapper"
      name="create-sms-sender-in-sequence-modal"
      :title="$t('frontend_groovemail_settings_integeration_settings')"
    >
      <VuePerfectScrollbar>
        <div class="scroll-modal-tab">
          <create-sms-sender
            ref="createSmsSender"
            @smsSenderCreated="smsSenderCreated"
          >
          </create-sms-sender>
          <div class="flex justify-end p-6 pt-0">
            <gd-button size="auto" @click="closeCreateSmsSenderModal">{{
              $t('frontend_cancel')
            }}</gd-button>
            <gd-button
              variant="primary"
              size="auto"
              @click="createNewSmsSender"
              class="ml-2"
            >
              {{ $t('frontend_groovemail_create_sender_route_page_title') }}
            </gd-button>
          </div>
        </div>
      </VuePerfectScrollbar>
    </gd-modal>

    <div class="w-full">
      <div id="startrule">
        <gd-button
          id="addrule"
          ref="addrule"
          variant="primary"
          size="md"
          @click="openNewRule"
          class="mr-4"
          style="display: none"
        >
          {{ $t('frontend_groovemail_sequences_configmenu_new_rule') }}
        </gd-button>

        <gd-button
          id="addtag"
          ref="addtag"
          variant="primary"
          size="md"
          @click="openNewTag"
          class="mr-4"
          style="display: none"
        >
          {{ $t('frontend_groovemail_sequences_configmenu_new_tag') }}
        </gd-button>

        <gd-button
          id="delcontrolbtn"
          ref="delcontrolbtn"
          variant="primary"
          size="auto"
          @click="delcontrol"
          style="display: none"
        >
          {{ $t('frontend_groovemail_sequences_configmenu_delete_control') }}
        </gd-button>

        <gd-button
          id="viewdetailbtn"
          variant="primary"
          size="auto"
          @click="openviewdetail"
          style="display: none"
        >
          {{ $t('frontend_groovemail_sequences_create_view') }}
        </gd-button>

        <gd-button
          id="editdetailbtn"
          variant="primary"
          size="auto"
          @click="openeditdetail"
          style="display: none"
        >
          {{ $t('frontend_groovemail_sequences_create_edit_detail') }}
        </gd-button>

        <gd-button
          data-moduleid
          id="activatenodebtn"
          variant="primary"
          size="auto"
          @click="activeNode"
          style="display: none"
        >
          {{ $t('frontend_groovemail_sequences_create_activate') }}
        </gd-button>

        <gd-button
          id="delnodebtn"
          ref="delnodebtn"
          variant="primary"
          size="auto"
          @click="delnode"
          style="display: none"
        >
          {{ $t('frontend_groovemail_sequences_create_delete_node') }}
        </gd-button>
      </div>
    </div>

    <portal to="headerContent">
      <gd-button
        variant="outline"
        size="auto"
        class="ml-2"
        @click="moveToSequenceListing"
      >
        {{ $t('frontend_groovemail_sequences_configmenu_exit') }}
      </gd-button>
      <gd-button
        variant="primary"
        size="auto"
        class="ml-2"
        @click="saveandexit"
      >
        {{ $t('frontend_save') }}
      </gd-button>
    </portal>
    <portal to="headerBreadCrumb">
      <div
        class="cursor-pointer self-center text-grey-500 hover:text-primary"
        @click="moveToSequenceListing"
      >
        <ExitIcon class="h-5 w-5" />
      </div>
    </portal>

    <!-- Confirmation Modal for delete -->
    <confirm-modal
      :ref="`confirmation-delete`"
      :name="`confirmation-delete`"
      :buttonText="$t('frontend_delete')"
      :cancelText="$t('frontend_cancel')"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="
        this.$t('frontend_groovemail_sequences_remove_confirmation')
      "
      @confirm="confirmDeleteNode"
    />
  </div>
</template>

<script>
import auth from '@groovepages/gd-lib/auth';
import moment from 'moment';
// import GdToggle from '@groovepages/gd-ui-kit/components/Toggle';

import axios from 'axios';
import Rete from 'rete';
import ConnectionPlugin from 'rete-connection-plugin';
import VueRenderPlugin from 'rete-vue-render-plugin';
import AlightRenderPlugin from 'rete-alight-render-plugin';
// import ContextMenuPlugin, { Menu, Item, Search, } from 'rete-context-menu-plugin';
// import ModulePlugin from 'rete-module-plugin';
import ReactRenderPlugin from // ,{ Node, Socket, Control }
'rete-react-render-plugin';
// import AreaPlugin from 'rete-area-plugin';
import DockPlugin from 'rete-dock-plugin';
import ConnectionPathPlugin from 'rete-connection-path-plugin';

// import ImagePickerWithoutModal from '@groovepages/gd-ui-kit/components/ImagePicker';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

import Mailsequence from '@/models/Mailsequence';
import Sequencemodule from '@/models/MailsequenceModule';

import showAlert from '@/components/sweet-alert-popup.js';
import scheduledTimeInEst from '@/components/scheduledTime.js';
import CreateEmailSender from '../settings/create.vue';
import CreateSmsSender from '../settings/create_integeration.vue';
import CreateTag from '@/components/create-tags.vue';
import CreateList from '@/components/create-lists.vue';
import i18n from '../../plugins/i18n';
import themeConfig from '@/theme/themeConfig.js';
import ConfigMenu from './config-menu';

// import icon
import ExitIcon from '@/assets/images/icons/new/exit_arrow_new.svg';
import PlusIcon from '@/assets/images/icons/new/plus-small_new.svg';
import MinusIcon from '@/assets/images/icons/new/minus_small_new.svg';
import VerticalLayoutIcon from '@/assets/images/icons/new/Vertical.svg';

// const numSocket = new Rete.Socket('Number');
// const floatSocket = new Rete.Socket('Float');
const anyTypeSocket = new Rete.Socket('Any type');
// const strSocket = new Rete.Socket('String');
// const actionSocket = new Rete.Socket('Action');
// const dataSocket = new Rete.Socket('Data');

let newstartrule = 'tag';
let tagnodecount = 0;
let listnodecount = 0;
let formnodecount = 0;
// const startrulenode = [];
const delcontrol = '';

// const opentagnodeid = '';
let tagdelayoption = '';
let selectedtags = '';
let tagaction = '';

let listdelayoption = '';
let selectedlists = '';
let listaction = '';

let editordata = '';
let newmoduleid = '';
let viewtype = '';
let selectedemails = '';
let selectedsms = '';
let selecteddelays = '';
let selectedgoto = '';
let nodestatus = '';
let selectedPostalCampaign = '';

let self = null;
let targetNode = null;

export default {
  layout: 'defaultWithoutSidebarLogo',
  middleware: 'auth',
  data() {
    return {
      zoomInDisabled: false,
      zoomOutDisabled: false,
      fullPageLoader: true,
      isLoading: false,
      loaderColor: themeConfig.appPrimaryColor,
      imagePickerVal: '',
      modalOpenedBy: 0,
      mail_list_data: { name: '', description: '' },
      mail_tag_data: {
        name: '',
        description: '',
        category: [],
        categoryname: ''
      },
      model: {
        retedata: '',
        status: 0,
        mainselect: 'list',
        list: '',
        tag: '',
        form: '',
        category: '',
        subscribedlists: [],
        assignedtags: [],
        subscribedforms: [],
        viewtype: 'vertical',
        saverulebtn: true,
        tagoption: 1,
        tagdelay: '',
        tagdelaydays: 0,
        tagdelayhours: 0,
        tagdelaydate: '',
        tagcurrentstep: 1,
        tagdays: [
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
          'Sunday'
        ],
        tagtime: 1,
        tagstarttime: '',
        tagendtime: '',
        tagaction: '',
        tagassigned: [],
        savetagbtn: false,
        currentopennode: '',
        listoption: 1,
        listdelay: '',
        listdelaydays: 0,
        listdelayhours: 0,
        listdelaydate: '',
        listcurrentstep: 1,
        listdays: [
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
          'Sunday'
        ],
        listtime: 1,
        liststarttime: '',
        listendtime: '',
        listaction: '',
        listassigned: [],
        savelistbtn: false,
        viewmoduledetail: {},
        editmodulestep: '',
        editstep: '',
        edittype: '',
        editcurrentstep: 1,
        editallowdays: [],
        editallowtime: 1,
        editstarttime: '',
        editendtime: '',
        editaction: 1,
        editassigned: [],
        editsavebtn: true,
        emailoption: 1,
        broadcast: '',
        sender_id: '-1',
        sendername: '',
        senderemail: '',
        replyemail: '',
        subject: '',
        previewtext: '',
        content: '',
        editor_type: 3,
        emailContentSections: '',
        email_id: null,
        template_name: '',
        template_folder: null,
        smsContent: '',
        emailassigned: [],
        timedelayoption: 1,
        timedelaydays: 0,
        timedelayhours: 0,
        timedelaydate: '',
        delaydays: [
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
          'Sunday'
        ],
        timedelaytime: 1,
        timedelaystarttime: '',
        timedelayendtime: '',
        timedelayaction: '',
        timedelayassigned: [],
        delaybtn: false,
        smsassigned: [],
        savesmsbtn: false,
        gotostep: '',
        gotoflow: '',
        gotoassigned: [],
        splitassigned: [],
        currentflowname: '',
        postalCampaign: '',
        postalSequenceId: ''
      }
    };
  },
  metaInfo() {
    return { title: 'Sequence' };
  },

  async created() {
    // Set the self variable to the current object
    self = this;

    // Get user settings from the server
    const userSettingsRes = await axios.get('/usersetting');

    // Set sender name, sender email, and reply email fields of the model object
    this.model.sendername = userSettingsRes.data.groovemail_sender_name
      ? userSettingsRes.data.groovemail_sender_name
      : this.$store.state.user.name;
    this.model.senderemail = userSettingsRes.data.groovemail_sender_email
      ? userSettingsRes.data.groovemail_sender_email
      : this.$store.state.user.email;
    this.model.replyemail = userSettingsRes.data.groovemail_reply_email
      ? userSettingsRes.data.groovemail_reply_email
      : this.$store.state.user.email;

    // Get the mail sequence with the specified ID
    const mailsequence = await Mailsequence.$find(this.$route.params.id);

    // Set the retedata field of the model object
    this.model.retedata = editordata =
      mailsequence.retedata !== '' ? JSON.parse(mailsequence.retedata) : [];

    // Set the subscribedlists, assignedsegments, assignedtags, and subscribedforms fields of the model object
    this.model.subscribedlists =
      typeof mailsequence.startrulelists === 'string'
        ? JSON.parse(mailsequence.startrulelists)
        : mailsequence.startrulelists
        ? mailsequence.startrulelists
        : [];
    this.model.assignedsegments =
      typeof mailsequence.startrulesegments === 'string'
        ? JSON.parse(mailsequence.startrulesegments)
        : mailsequence.startrulesegments
        ? mailsequence.startrulesegments
        : [];
    this.model.assignedtags =
      typeof mailsequence.startruletags === 'string'
        ? JSON.parse(mailsequence.startruletags)
        : mailsequence.startruletags
        ? mailsequence.startruletags
        : [];
    this.model.subscribedforms =
      typeof mailsequence.startruleforms === 'string'
        ? JSON.parse(mailsequence.startruleforms)
        : mailsequence.startruleforms
        ? mailsequence.startruleforms
        : [];

    // Set the viewtype and currentflowname fields of the model object
    this.model.viewtype = viewtype = mailsequence.viewtype;
    this.model.currentflowname = mailsequence.name;
  },

  async mounted() {
    var verLayout = document.getElementsByClassName('vertical-layout-icon')[0]
      .childNodes;
    var horLayout = document.getElementsByClassName('horizontal-layout-icon')[0]
      .childNodes;
    if (horLayout[0]) horLayout[0].style.fill = '#989ab2';
    if (verLayout[0]) verLayout[0].style.fill = '#989ab2';

    const sequenceDetail = await Mailsequence.$find(this.$route.params.id);
    const container = this.$refs.rete;
    this.editor = new Rete.NodeEditor('demo@0.1.0', container);

    this.editor.use(ConnectionPlugin, { curvature: 0.4 });
    this.editor.use(ConnectionPathPlugin, {
      type: ConnectionPathPlugin.LINEAR, // DEFAULT or LINEAR transformer
      transformer: () => ([x1, y1, x2, y2]) => [
        [x1, y1],
        [x2, y2]
      ], // optional, custom transformer
      curve:
        sequenceDetail.viewtype === 'vertical'
          ? ConnectionPathPlugin.curveBasis
          : ConnectionPathPlugin.curveStep, // curve identifier
      options: { vertical: false, curvature: 0.4 } // optional
      // arrow: { color: '#fd6481', marker: 'M7,-1 L7,14 L17,7 z' }, // marker: 'M 0 -10 L 0 10 L 10 0 Z' }
    });
    this.editor.use(AlightRenderPlugin);
    this.editor.use(ReactRenderPlugin);
    this.editor.use(DockPlugin, {
      container: document.querySelector('#dock'),
      itemClass: 'item',
      plugins: [VueRenderPlugin]
    });

    const components = [
      new StartComponent(),
      new EmailComponent(),
      new SendSMSComponent(),
      new PostalComponent(),
      new AddTagComponent(),
      new RemoveTagComponent(),
      new SubscribeListComponent(),
      new UnsubscribeListComponent(),
      new EndComponent(),
      new DelayComponent(),
      new ConditionalSplitComponent()
      // new GotoComponent(),
    ];

    // const integrations = this.fetchClosemIntegeration();
    // if (integrations && integrations.length) {
    //   components.splice(3, 0, new PostalComponent());
    // }

    const engine = new Rete.Engine('demo@0.1.0');

    components.map(c => {
      this.editor.register(c);
      engine.register(c);
    });

    this.showLoader();
    const mailsequence = await Mailsequence.$find(this.$route.params.id);
    const retedata = JSON.parse(mailsequence.retedata);

    // check if retedata is not empty and load the editor with the retedata
    if (retedata != '') {
      await this.editor.fromJSON(retedata);
    } else {
      const module1 = await components[0].createNode();
      module1.position =
        mailsequence.viewtype === 'vertical' ? [500, 100] : [300, 200];
      this.editor.addNode(module1);
    }
    this.hideLoader();

    var verLayout = document.getElementsByClassName('vertical-layout-icon')[0]
      .childNodes;
    var horLayout = document.getElementsByClassName('horizontal-layout-icon')[0]
      .childNodes;
    if (mailsequence.viewtype === 'vertical') {
      if (verLayout[0]) verLayout[0].style.fill = themeConfig.appPrimaryColor;
      if (horLayout[0]) horLayout[0].style.fill = '#989ab2';
    } else {
      if (verLayout[0]) verLayout[0].style.fill = '#989ab2';
      if (horLayout[0]) horLayout[0].style.fill = themeConfig.appPrimaryColor;
    }

    this.hideLoader();

    this.editor.on('zoom', ({ source }) => {
      return source !== 'wheel';
    });

    this.editor.on('process', async () => {
      if (this.editor.silent) return;
      await engine.abort();
      await engine.process(this.editor.toJSON());
      editordata = this.editor.toJSON();
    });

    this.editor.on('connectionremoved', async () => {
      editordata = this.editor.toJSON();
      this.showLoader();
      this.saveeditordata();
      this.hideLoader();
    });

    this.editor.on('connectioncreated', async connection => {
      editordata = this.editor.toJSON();
      this.showLoader();
      await this.saveeditordata();
      if (
        connection &&
        connection.input &&
        connection.input.key &&
        connection.input.key === 'endInput'
      ) {
        await this.saveEndNode(connection);
      }
      this.hideLoader();
    });

    this.editor.on('noderemoved', async node => {
      this.$refs.configMenu.toggleConfigMenu(false);
      this.model.sender_id = '-1';
      editordata = this.editor.toJSON();
      this.showLoader();
      if (node.data.moduleid && node.data.moduleid !== '') {
        const sequencemodule = await Sequencemodule.$find(node.data.moduleid);
        await sequencemodule.delete();
      }
      this.saveeditordata();
      this.hideLoader();
    });

    this.editor.on('nodecreated', node => {
      this.openTriggerMenu(node.id, node.name);
      let outputkey;
      let inputkey;
      const keys = Object.keys(this.editor.toJSON().nodes);
      outputkey = Object.keys(
        this.editor.toJSON().nodes[keys[keys.length - 2]].outputs
      )[0];
      inputkey = Object.keys(
        this.editor.toJSON().nodes[keys[keys.length - 1]].inputs
      )[0];

      const totalnodes = this.editor.nodes.length;
      const previousnode = totalnodes - 2;

      if (
        !(
          this.editor.nodes[previousnode].name === 'Conditional Split' ||
          this.editor.nodes[previousnode].name === 'Goto'
        )
      ) {
        this.editor.connect(
          this.editor.nodes[previousnode].outputs.get(outputkey),
          node.inputs.get(inputkey)
        );
      }
      editordata = this.editor.toJSON();
    });

    this.editor.on('rendercontrol', ({ control }) => {
      const totalnodes = this.editor.nodes.length;
      const previousnode = totalnodes - 2;
      const prevnodeposition = this.editor.nodes[previousnode].position;
      if (totalnodes <= 2) {
        control.parent.position =
          this.model.viewtype === 'vertical'
            ? [prevnodeposition[0], prevnodeposition[1] + 350]
            : [prevnodeposition[0] + 450, 250];
      } else if (totalnodes > 2) {
        control.parent.position =
          this.model.viewtype === 'vertical'
            ? [prevnodeposition[0], prevnodeposition[1] + 250]
            : [prevnodeposition[0] + 450, 250];
      }
      editordata = this.editor.toJSON();
    });
  },

  components: {
    ConfigMenu,
    VerticalLayoutIcon,
    CreateList,
    CreateTag,
    CreateSmsSender,
    CreateEmailSender,
    VuePerfectScrollbar,
    ExitIcon,
    PlusIcon,
    MinusIcon
  },

  methods: {
    // confirm delete
    confirmDeleteNode() {
      this.showLoader();

      try {
        // remove the node from the editor
        this.editor.removeNode(targetNode);

        // reset target and targetNode
        targetNode = null;
      } catch (error) {
        this.hideLoader();
        showAlert('error', error.response?.data?.error);
      }
    },

    openCreateListModal(type) {
      this.modalOpenedBy = type;
      this.mail_list_data.name = '';
      this.mail_list_data.description = '';
      this.$root.$emit('modal-open', 'create-maillist-in-sequence-modal');
    },

    async fetchEventsList(listData) {
      this.$refs.configMenu.passCreatedLists(listData, this.modalOpenedBy);
    },

    closeCreateMaillist() {
      this.$root.$emit('modal-close', 'create-maillist-in-sequence-modal');
    },

    openCreateTagModal(type) {
      this.modalOpenedBy = type;
      this.mail_tag_data.name = '';
      this.mail_tag_data.description = '';
      this.mail_tag_data.category = [];
      this.mail_tag_data.categoryname = '';
      this.$root.$emit('modal-open', 'create-mailtag-in-sequence-modal');
    },

    async fetchEventsTags(tagData) {
      this.$refs.configMenu.passCreatedTags(tagData, this.modalOpenedBy);
    },

    closeCreateMailtag() {
      this.$root.$emit('modal-close', 'create-mailtag-in-sequence-modal');
    },

    async createNewEmailSender() {
      await this.$refs.createEmailSender.createNewSender();
    },

    async emailSenderCreated(senderData) {
      this.$root.$emit('modal-close', 'create-email-sender-in-sequence-modal');
      this.$refs.configMenu.passCreatedEmailSender(
        senderData,
        this.modalOpenedBy
      );
    },

    openCreateEmailSenderModal(type) {
      this.modalOpenedBy = type;
      this.$root.$emit('modal-open', 'create-email-sender-in-sequence-modal');
    },

    closeCreateEmailSenderModal() {
      this.$root.$emit('modal-close', 'create-email-sender-in-sequence-modal');
    },

    async createNewSmsSender() {
      await this.$refs.createSmsSender.createNewSmsSender();
    },

    async smsSenderCreated(senderData) {
      this.$root.$emit('modal-close', 'create-sms-sender-in-sequence-modal');
      this.$refs.configMenu.passCreatedSmsSender(
        senderData,
        this.modalOpenedBy
      );
    },

    openCreateSmsSenderModal(type) {
      this.modalOpenedBy = type;
      this.$root.$emit('modal-open', 'create-sms-sender-in-sequence-modal');
    },

    closeCreateSmsSenderModal() {
      this.$root.$emit('modal-close', 'create-sms-sender-in-sequence-modal');
    },

    configurationMenuClosed() {
      const newModel = {
        retedata: '',
        mainselect: 'list',
        list: '',
        tag: '',
        form: '',
        category: '',
        saverulebtn: true,
        tagoption: 1,
        tagdelay: '',
        tagdelaydays: 0,
        tagdelayhours: 0,
        tagdelaydate: '',
        tagcurrentstep: 1,
        tagdays: [
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
          'Sunday'
        ],
        tagtime: 1,
        tagstarttime: '',
        tagendtime: '',
        tagaction: '',
        tagassigned: [],
        savetagbtn: false,
        currentopennode: '',
        listoption: 1,
        listdelay: '',
        listdelaydays: 0,
        listdelayhours: 0,
        listdelaydate: '',
        listcurrentstep: 1,
        listdays: [
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
          'Sunday'
        ],
        listtime: 1,
        liststarttime: '',
        listendtime: '',
        listaction: '',
        listassigned: [],
        savelistbtn: false,
        viewmoduledetail: {},
        editmodulestep: '',
        editstep: '',
        edittype: '',
        editcurrentstep: 1,
        editallowdays: [],
        editallowtime: 1,
        editstarttime: '',
        editendtime: '',
        editaction: 1,
        editassigned: [],
        editsavebtn: true,
        emailoption: 1,
        broadcast: '',
        sendername: '',
        senderemail: '',
        replyemail: '',
        sender_id: '-1',
        subject: '',
        previewtext: '',
        content: '',
        editor_type: 3,
        emailContentSections: '',
        email_id: null,
        template_name: '',
        template_folder: null,
        smsContent: '',
        emailassigned: [],
        timedelayoption: 1,
        timedelaydays: 0,
        timedelayhours: 0,
        timedelaydate: '',
        delaydays: [
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
          'Sunday'
        ],
        timedelaytime: 1,
        timedelaystarttime: '',
        timedelayendtime: '',
        timedelayaction: '',
        timedelayassigned: [],
        delaybtn: false,
        smsassigned: [],
        savesmsbtn: false,
        gotostep: '',
        gotoflow: '',
        gotoassigned: [],
        splitassigned: [],
        currentflowname: '',
        postalCampaign: '',
        postalSequenceId: ''
      };
      this.model = { ...this.model, ...newModel };
    },

    async saveandexit() {
      try {
        this.showLoader();
        this.mailsequence = await Mailsequence.$find(this.$route.params.id);
        this.mailsequence.retedata = JSON.stringify(editordata);
        this.mailsequence.id = this.$route.params.id;
        this.mailsequence.startruletags = JSON.stringify(
          this.model.assignedtags
        );
        this.mailsequence.startrulelists = JSON.stringify(
          this.model.subscribedlists
        );
        this.mailsequence.startrulesegments = JSON.stringify(
          this.model.assignedsegments
        );
        this.mailsequence.startruleforms = JSON.stringify(
          this.model.subscribedforms
        );

        await this.mailsequence.save();
        this.$router.push({ name: 'SequencesLegacy' });

        // hide loader
        this.hideLoader();
      } catch (error) {
        // show error alert
        this.requestErrorAlert(error.response?.data?.error);
      }
    },

    moveToSequenceListing() {
      this.$router.push({
        name: 'SequencesLegacy'
      });
    },

    async changeview(option) {
      this.showLoader();

      this.model.viewtype = viewtype = option;
      const changeview = document.querySelector('#changeview');
      changeview.click();

      try {
        this.mailsequence = await Mailsequence.$find(this.$route.params.id);
        this.mailsequence.id = this.$route.params.id;
        this.mailsequence.viewtype = this.model.viewtype;
        this.mailsequence.retedata = JSON.stringify(editordata);
        this.mailsequence.startruletags = JSON.stringify(
          this.model.assignedtags
        );
        this.mailsequence.startrulelists = JSON.stringify(
          this.model.subscribedlists
        );
        this.mailsequence.startrulesegments = JSON.stringify(
          this.model.assignedsegments
        );
        this.mailsequence.startruleforms = JSON.stringify(
          this.model.subscribedforms
        );

        await this.mailsequence.save();

        this.hideLoader();
      } catch (error) {
        // show error alert
        this.requestErrorAlert(error.response?.data?.error);

        return;
      }

      this.$router.go(this.$router.currentRoute);
    },

    onMouseWheelChange(event) {
      if (event.ctrlKey) {
        if (event.deltaY > 0) {
          this.zoomIn(0.05);
        } else {
          this.zoomOut(-0.05);
        }
      } else {
        const { area } = this.editor.view;
        const modulusDeltaX = event.deltaX > 0 ? event.deltaX : -event.deltaX;
        const modulusDeltaY = event.deltaY > 0 ? event.deltaY : -event.deltaY;
        if (modulusDeltaX > modulusDeltaY) {
          if (event.deltaX > 0) {
            area.transform.x -= 8;
          } else {
            area.transform.x += 8;
          }
        } else if (event.deltaY > 0) {
          area.transform.y -= 8;
        } else {
          area.transform.y += 8;
        }
      }
    },

    zoomIn(k) {
      if (this.editor.view.area.transform.k < 1.3) {
        this.calculateZoom(k);
      }
    },

    zoomOut(k) {
      if (this.editor.view.area.transform.k > 0.3) {
        this.calculateZoom(k);
      }
    },

    calculateZoom(k) {
      const { area, container } = this.editor.view; // read from Vue component data;
      const rect = area.el.getBoundingClientRect();
      const ox = (rect.left - container.clientWidth / 2) * k;
      const oy = (rect.top - container.clientHeight / 2) * k;

      area.zoom(area.transform.k + k, ox, oy);
      if (this.editor.view.area.transform.k >= 1.3) {
        this.zoomInDisabled = true;
      } else {
        this.zoomInDisabled = false;
      }

      if (this.editor.view.area.transform.k <= 0.3) {
        this.zoomOutDisabled = true;
      } else {
        this.zoomOutDisabled = false;
      }
    },

    openTriggerMenu(nodeId, nodeName) {
      this.model.currentopennode = nodeId;

      if (nodeName === 'Add Tag') {
        this.$refs.configMenu.toggleConfigMenu(true);
        this.$refs.configMenu.seqAction = {
          type: 'tag',
          value: 1
        };
        this.$refs.configMenu.title = `${this.$t(
          'frontend_groovemail_sequence_configure'
        )} "Add Tag" ${this.$t('frontend_groovemail_sequences_actions_text')}`;
      } else if (nodeName === 'Remove Tag') {
        this.$refs.configMenu.toggleConfigMenu(true);
        this.$refs.configMenu.seqAction = {
          type: 'tag',
          value: 2
        };
        this.$refs.configMenu.title = `${this.$t(
          'frontend_groovemail_sequence_configure'
        )} "Remove Tag" ${this.$t(
          'frontend_groovemail_sequences_actions_text'
        )}`;
      } else if (nodeName === 'Subscribe To List') {
        this.$refs.configMenu.toggleConfigMenu(true);
        this.$refs.configMenu.seqAction = {
          type: 'list',
          value: 1
        };
        this.$refs.configMenu.title = `${this.$t(
          'frontend_groovemail_sequence_configure'
        )} "Subscribe List" ${this.$t(
          'frontend_groovemail_sequences_actions_text'
        )}`;
      } else if (nodeName === 'Unsubscribe From List') {
        this.$refs.configMenu.toggleConfigMenu(true);
        this.$refs.configMenu.seqAction = {
          type: 'list',
          value: 2
        };
        this.$refs.configMenu.title = `${this.$t(
          'frontend_groovemail_sequence_configure'
        )} "Unsubscribe From List" ${this.$t(
          'frontend_groovemail_sequences_actions_text'
        )}`;
      } else if (nodeName === 'Send Email') {
        this.$refs.configMenu.toggleConfigMenu(true);
        this.$refs.configMenu.seqAction = {
          type: 'email',
          value: 1
        };
        this.$refs.configMenu.title = `${this.$t(
          'frontend_groovemail_sequence_configure'
        )} "Send Email" ${this.$t(
          'frontend_groovemail_sequences_actions_text'
        )}`;
      } else if (nodeName === 'Time Delay') {
        this.$refs.configMenu.toggleConfigMenu(true);
        this.$refs.configMenu.seqAction = {
          type: 'delay',
          value: 1
        };
        this.$refs.configMenu.title = `${this.$t(
          'frontend_groovemail_sequence_configure'
        )} "Time Delay" ${this.$t(
          'frontend_groovemail_sequences_actions_text'
        )}`;
      } else if (nodeName === 'Send SMS') {
        this.$refs.configMenu.toggleConfigMenu(true);
        this.$refs.configMenu.seqAction = {
          type: 'sms',
          value: 1
        };
        this.$refs.configMenu.title = `${this.$t(
          'frontend_groovemail_sequence_configure'
        )} "Send SMS" ${this.$t('frontend_groovemail_sequences_actions_text')}`;
      } else if (nodeName === 'Automation') {
        this.$refs.configMenu.toggleConfigMenu(true);
        this.$refs.configMenu.seqAction = {
          type: 'automation',
          value: 1
        };
        this.$refs.configMenu.title = `${this.$t(
          'frontend_groovemail_sequence_configure'
        )} "Automation" ${this.$t(
          'frontend_groovemail_sequences_actions_text'
        )}`;
      } else if (nodeName === 'Conditional Split') {
        this.$refs.configMenu.toggleConfigMenu(true);
        this.$refs.configMenu.seqAction = {
          type: 'split',
          value: 1
        };
        this.$refs.configMenu.title = `${this.$t(
          'frontend_groovemail_sequence_configure'
        )} "Conditional Split" ${this.$t(
          'frontend_groovemail_sequences_actions_text'
        )}`;
      } else if (nodeName === 'Goto') {
        this.$refs.configMenu.toggleConfigMenu(true);
        this.$refs.configMenu.seqAction = {
          type: 'goto',
          value: 1
        };
        this.$refs.configMenu.title = `${this.$t(
          'frontend_groovemail_sequence_configure'
        )} "Goto" ${this.$t('frontend_groovemail_sequences_actions_text')}`;
      } else if (nodeName === 'Send Postcards') {
        this.postalCreationFlow();
      }
    },

    postalCreationFlow() {
      // const integrations = this.fetchClosemIntegeration();
      // if (!(integrations && integrations.length)) {
      // this.showClosemIntegrationPopup();
      // } else {
      this.$refs.configMenu.toggleConfigMenu(true);
      this.$refs.configMenu.seqAction = {
        type: 'postal',
        value: 1
      };
      this.$refs.configMenu.title = `${this.$t(
        'frontend_groovemail_sequence_configure'
      )} "Send Postcards" ${this.$t(
        'frontend_groovemail_sequences_actions_text'
      )}`;
      // }
    },

    showClosemIntegrationPopup() {
      const user = auth.authenticatedUser();
      const signupLink = `${'https://groove.closem.ai/?fpr=groove'}&name=${
        user.name
      }&email=${user.email}&phone=`;
      showAlert({
        iconType: 'alert-question',
        html: `
          <style>.swal2-confirm { color: ${
            themeConfig.appPrimaryColorInvert
          } !important; }</style>
          <p class="text-sm text-deep-dark">
            ${this.$t(
              'frontend_groovemail_campaigns_create_disabled_postal_type_message'
            )}
            <a class="text-primary underline" target="_blank" href="${signupLink}">
              ${this.$t(
                'frontend_groovemail_campaigns_create_disabled_postal_type_message_click_here'
              )}
                </p>
            </a>
          </p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: this.$t('frontend_close')
      });
    },

    editbackstep() {
      this.model.editmodulestep = '';
    },

    listbackstep() {
      if (this.model.listcurrentstep !== 1) {
        if (this.model.listoption !== 3) {
          this.model.listcurrentstep = this.model.listcurrentstep - 1;
        } else {
          this.model.listcurrentstep = this.model.listcurrentstep - 2;
        }
      }
    },

    listnextstep() {
      if (this.model.listcurrentstep !== 3) {
        if (this.model.listoption !== 3) {
          this.model.listcurrentstep = this.model.listcurrentstep + 1;
        } else {
          this.model.listcurrentstep = this.model.listcurrentstep + 2;
        }
      }
    },

    async saveeditordata() {
      this.showLoader();

      try {
        this.mailsequence = await Mailsequence.$find(this.$route.params.id);
        this.mailsequence.retedata = JSON.stringify(editordata);
        this.mailsequence.id = this.$route.params.id;
        this.mailsequence.startruletags = JSON.stringify(
          this.model.assignedtags
        );
        this.mailsequence.startrulelists = JSON.stringify(
          this.model.subscribedlists
        );
        this.mailsequence.startrulesegments = JSON.stringify(
          this.model.assignedsegments
        );
        this.mailsequence.startruleforms = JSON.stringify(
          this.model.subscribedforms
        );
        this.mailsequence.viewtype = this.model.viewtype;

        await this.mailsequence.save();
        this.hideLoader();
      } catch (error) {
        // show error alert
        this.requestErrorAlert(error.response?.data?.error);
      }
    },

    async saveEndNode() {
      try {
        this.showLoader();
        this.seqmodule = new Sequencemodule({});
        this.seqmodule.sequence_id = this.$route.params.id;
        this.seqmodule.node_id = this.model.currentopennode;
        this.seqmodule.type = 'end-sequence';
        this.seqmodule.retedata = JSON.stringify([]);
        this.seqmodule.status = 1;

        const response = await this.seqmodule.save();
        newmoduleid = response.id;
        this.$refs.configMenu.toggleConfigMenu(false);

        const saveend = document.querySelector(
          `#saveend${this.model.currentopennode}`
        );
        saveend.click();
        this.saveeditordata();
        this.hideLoader();
      } catch (error) {
        // show error alert
        this.requestErrorAlert(error.response?.data?.error);
      }
    },

    async savetag(data) {
      this.showLoader();

      if (this.model.tagoption === 1) {
        tagdelayoption = 'Immediately after prev...';
      } else if (this.model.tagoption === 2) {
        tagdelayoption = `${this.model.tagdelaydays} days and ${this.model.tagdelayhours} hours`;
      } else if (this.model.tagoption === 3) {
        tagdelayoption = this.model.tagdelaydate;
      }

      if (data.action === 1) {
        tagaction = 'Add Tag';
      } else {
        tagaction = 'Remove Tag';
      }

      this.seqmodule = new Sequencemodule({});
      this.seqmodule.sequence_id = this.$route.params.id;
      this.seqmodule.node_id = this.model.currentopennode;
      this.seqmodule.type = 'tag';
      this.seqmodule.allow_days = JSON.stringify([]);
      this.seqmodule.action = data.action;
      this.seqmodule.retedata = JSON.stringify(this.model.tagassigned);
      this.seqmodule.status = this.model.status;

      try {
        const response = await this.seqmodule.save();
        newmoduleid = response.id;
      } catch (error) {
        // show error alert
        this.requestErrorAlert(error.response?.data?.error);

        return;
      }

      this.$refs.configMenu.toggleConfigMenu(false);

      const tagsname = [];
      for (let i = 0; i < this.model.tagassigned.length; i += 1) {
        tagsname.push(this.model.tagassigned[i].name);
      }
      selectedtags = tagsname.join(', ');
      nodestatus = this.model.status === 1 ? 'Active' : 'Inactive';
      const savetag = document.querySelector(
        `#savetag${this.model.currentopennode}`
      );
      savetag.click();
      this.saveeditordata();

      this.model.tag = '';
      this.model.category = '';
      this.model.tagoption = 1;
      this.model.tagdelayhours = 0;
      this.model.tagdelaydate = '';
      this.model.tagdelay = '';
      this.model.tagdelaydays = 0;
      this.model.tagcurrentstep = 1;
      this.model.tagtime = 1;
      this.model.tagstarttime = '';
      this.model.tagendtime = '';
      this.model.tagaction = '';
      this.model.tagassigned = [];

      this.hideLoader();
    },

    async savelist(data) {
      this.showLoader();

      if (this.model.listoption === 1) {
        listdelayoption = 'Immediately after prev..';
      } else if (this.model.listoption === 2) {
        listdelayoption = `${this.model.listdelaydays} days and ${this.model.listdelayhours} hours`;
      } else if (this.model.listoption === 3) {
        listdelayoption = this.model.listdelaydate;
      }

      if (data.action === 1) {
        listaction = 'Subscribe List';
      } else {
        listaction = 'Unsubscribe List';
      }

      this.seqmodule = new Sequencemodule({});
      this.seqmodule.sequence_id = this.$route.params.id;
      this.seqmodule.node_id = this.model.currentopennode;
      this.seqmodule.type = 'list';
      this.seqmodule.allow_days = JSON.stringify([]);
      this.seqmodule.action = data.action;
      this.seqmodule.retedata = JSON.stringify(this.model.listassigned);
      this.seqmodule.status = this.model.status;

      try {
        const response = await this.seqmodule.save();
        newmoduleid = response.id;
      } catch (error) {
        // show error alert
        this.requestErrorAlert(error.response?.data?.error);

        return;
      }

      this.$refs.configMenu.toggleConfigMenu(false);

      const listsname = [];
      for (let i = 0; i < this.model.listassigned.length; i += 1) {
        listsname.push(this.model.listassigned[i].name);
      }
      selectedlists = listsname.join(', ');
      nodestatus = this.model.status === 1 ? 'Active' : 'Inactive';
      const savelist = document.querySelector(
        `#savelist${this.model.currentopennode}`
      );
      savelist.click();
      this.saveeditordata();

      this.model.list = '';
      this.model.listoption = 1;
      this.model.listdelay = '';
      this.model.listdelaydays = 0;
      this.model.listdelayhours = 0;
      this.model.listdelaydate = '';
      this.model.listcurrentstep = 1;
      this.model.listtime = 1;
      this.model.liststarttime = '';
      this.model.listendtime = '';
      this.model.listaction = '';
      this.model.listassigned = [];

      this.hideLoader();
    },

    async updatemoduledetail() {
      this.showLoader();

      try {
        this.sequencemodule = await Sequencemodule.$find(
          this.model.viewmoduledetail.id
        );
        this.sequencemodule.delayoption = this.model.timedelayoption;
        this.sequencemodule.delaydays = +this.model.timedelaydays;
        this.sequencemodule.delayhours = this.model.timedelayhours;
        this.sequencemodule.delaydate =
          [3,4,5,6].includes(this.model.timedelayoption) ? this.model.timedelaydate : '';
        this.sequencemodule.allow_days = JSON.stringify(
          this.model.editallowdays
        );
        this.sequencemodule.allow_time = this.model.editallowtime;
        this.sequencemodule.start_time = this.model.editstarttime;
        this.sequencemodule.end_time = this.model.editendtime;
        this.sequencemodule.broadcast = this.model.broadcast;
        this.sequencemodule.sender_id = this.model.sender_id;
        this.sequencemodule.sendername = this.model.sendername;
        this.sequencemodule.senderemail = this.model.senderemail;
        this.sequencemodule.replyemail = this.model.replyemail;
        this.sequencemodule.subject = this.model.subject;
        this.sequencemodule.previewtext = this.model.previewtext;
        this.sequencemodule.content =
          this.model.edittype === 'email'
            ? this.model.content
            : this.model.edittype === 'sms'
            ? this.model.smsContent
            : '';
        this.sequencemodule.emailContentSections =
          this.model.edittype === 'email'
            ? this.model.emailContentSections
              ? typeof this.model.emailContentSections === 'string'
                ? this.model.emailContentSections
                : JSON.stringify(this.model.emailContentSections)
              : ''
            : '';
        this.sequencemodule.status = this.model.status;
        if (this.model.edittype === 'email' && this.model.editor_type) {
          this.sequencemodule.editor_type = this.model.editor_type;
        }
        if (this.model.edittype === 'email') {
          this.sequencemodule.email_id = this.model.email_id;
        }
        if (this.model.edittype === 'email' && this.model.template_name) {
          this.sequencemodule.template_name = this.model.template_name;
        }
        if (this.model.edittype === 'email' && this.model.template_folder) {
          this.sequencemodule.template_subcategory_id = this.model.template_folder;
        }
        this.sequencemodule.postal_sequence_id = this.model.postalSequenceId;
        this.sequencemodule.postalCampaign = this.model.postalCampaign;
        if (this.model.edittype === 'postal') {
          this.sequencemodule.retedata = JSON.stringify([
            { id: this.model.postalSequenceId, name: this.model.postalCampaign }
          ]);
        } else {
          this.sequencemodule.retedata = JSON.stringify(
            this.model.editassigned
          );
        }
        if (
          (this.model.edittype === 'email' && this.model.sender_id === '-1') ||
          (this.model.edittype === 'sms' && this.model.sender_id === '-1')
        ) {
          this.hideLoader();
          showAlert({
            iconType: 'alert-error',
            html: `
              <style>.swal2-confirm { color: ${
                themeConfig.appPrimaryColorInvert
              } !important; }</style>
              <p class="text-sm text-deep-dark"> ${this.$t(
                'frontend_groovemail_campaigns_create_select_sender_to_proceed'
              )}</p>
            `,
            showCancelButton: false,
            showCloseButton: true,
            confirmButtonColor: themeConfig.appPrimaryColor,
            confirmButtonText: this.$t('frontend_close')
          });
          return false;
        }

        const response = await this.sequencemodule.save();
        this.model.viewmoduledetail = response;
        this.$refs.configMenu.toggleConfigMenu(false);
      } catch (error) {
        // show error alert
        this.requestErrorAlert(error.response?.data?.error);
      }

      nodestatus = this.model.status === 1 ? 'Active' : 'Inactive';

      if (this.model.edittype === 'list' || this.model.edittype === 'tag') {
        const name = [];
        for (let i = 0; i < this.model.editassigned.length; i += 1) {
          name.push(this.model.editassigned[i].name);
        }

        if (this.model.edittype === 'list') {
          selectedlists = name.join(', ');
        } else {
          selectedtags = name.join(', ');
        }
      }

      if (this.model.edittype === 'email') {
        selectedemails = this.model.broadcast;
        this.model.broadcast = '';
        this.model.senderemail = '';
        this.model.sendername = '';
        this.model.replyemail = '';
        this.model.subject = '';
        this.model.previewtext = '';
        this.model.content = '';
        this.model.editor_type = 3;
        this.model.emailContentSections = '';
        this.model.email_id = null;
        this.model.template_name = '';
        this.model.template_folder = null;
        this.model.sender_id = '-1';
        this.model.emailassigned = [];
      }

      if (this.model.edittype === 'sms') {
        selectedsms = this.model.broadcast;
        this.model.broadcast = '';
        this.model.sender_id = '-1';
        this.model.smsContent = '';
      }

      if (this.model.edittype === 'postal') {
        selectedPostalCampaign = this.model.postalCampaign;
        this.model.postalCampaign = '';
        this.model.postalSequenceId = '';
      }

      if (this.model.edittype === 'goto') {
        selectedgoto = this.model.editassigned[0].step;
      }

      if (this.model.edittype === 'delay') {
        if (this.model.timedelayoption === 1) {
          selecteddelays = 'Immediately after previous step';
        }
        if (this.model.timedelayoption === 2) {
          selecteddelays = `${this.model.timedelaydays} days and ${this.model.timedelayhours} hours`;
        }
        if (this.model.timedelayoption === 3) {
          selecteddelays = scheduledTimeInEst(this.model.timedelaydate);
        }
        if (this.model.timedelayoption === 4) {
          selecteddelays = `At dynamic date: ${this.model.timedelaydate}`;
        }
        if (this.model.timedelayoption === 5) {
          selecteddelays = `${this.model.timedelaydays} days and ${this.model.timedelayhours} hours`;
          selecteddelays += ` BEFORE dynamic date: ${this.model.timedelaydate}`;
        }
        if (this.model.timedelayoption === 6) {
          selecteddelays = `${this.model.timedelaydays} days and ${this.model.timedelayhours} hours`;
          selecteddelays += ` AFTER dynamic date: ${this.model.timedelaydate}`;
        }
      }

      const updatemodule = document.querySelector(
        `#updatemodule${this.model.currentopennode}`
      );
      updatemodule.click();
      this.saveeditordata();

      this.hideLoader();
    },

    async saveOnEmailContentReset() {
      this.showLoader();

      try {
        this.sequencemodule = await Sequencemodule.$find(
          this.model.viewmoduledetail.id
        );
        this.sequencemodule.delayoption = this.model.timedelayoption;
        this.sequencemodule.delaydays = +this.model.timedelaydays;
        this.sequencemodule.delayhours = this.model.timedelayhours;
        this.sequencemodule.delaydate =
          [3,4,5,6].includes(this.model.timedelayoption) ? this.model.timedelaydate : '';
        this.sequencemodule.allow_days = JSON.stringify(
          this.model.editallowdays
        );
        this.sequencemodule.allow_time = this.model.editallowtime;
        this.sequencemodule.start_time = this.model.editstarttime;
        this.sequencemodule.end_time = this.model.editendtime;
        this.sequencemodule.broadcast = this.model.broadcast;
        this.sequencemodule.sender_id = this.model.sender_id;
        this.sequencemodule.sendername = this.model.sendername;
        this.sequencemodule.senderemail = this.model.senderemail;
        this.sequencemodule.replyemail = this.model.replyemail;
        this.sequencemodule.subject = this.model.subject;
        this.sequencemodule.previewtext = this.model.previewtext;
        this.sequencemodule.editor_type = this.editor_type;
        this.sequencemodule.content = this.model.content || '';
        this.sequencemodule.emailContentSections = this.model
          .emailContentSections
          ? typeof this.model.emailContentSections === 'string'
            ? this.model.emailContentSections
            : JSON.stringify(this.model.emailContentSections)
          : '';
        this.sequencemodule.status = this.model.status;
        this.sequencemodule.retedata = JSON.stringify(this.model.editassigned);
        this.sequencemodule.email_id = this.model.email_id || null;
        this.sequencemodule.template_name = this.model.template_name || '';
        this.sequencemodule.template_subcategory_id =
          this.model.template_folder || null;

        // save the module
        await this.sequencemodule.save();

        // hide loader
        this.hideLoader();
      } catch (error) {
        // show error alert
        this.requestErrorAlert(error.response?.data?.error);
      }
    },

    async saverule() {
      newstartrule = this.model.mainselect;
      tagnodecount =
        this.model.assignedtags && this.model.assignedtags.length
          ? this.model.assignedtags.length
          : 0;
      listnodecount =
        this.model.subscribedlists && this.model.subscribedlists.length
          ? this.model.subscribedlists.length
          : 0;
      formnodecount =
        this.model.subscribedforms && this.model.subscribedforms.length
          ? this.model.subscribedforms.length
          : 0;
      const saverule = document.querySelector('#saverule');
      saverule.click();
      this.saveeditordata();

      this.$refs.configMenu.toggleConfigMenu(false);

      this.$root.$emit('modal-close', 'startrule-model');
    },

    async savesmsdetail() {
      if (this.model.sender_id && this.model.sender_id !== '-1') {
        this.showLoader();
        this.seqmodule = new Sequencemodule({});
        this.seqmodule.sequence_id = this.$route.params.id;
        this.seqmodule.broadcast = this.model.broadcast;
        this.seqmodule.content = this.model.smsContent;
        this.seqmodule.emailContentSections = '';
        this.seqmodule.node_id = this.model.currentopennode;
        this.seqmodule.sender_id = this.model.sender_id;
        this.seqmodule.type = 'sms';
        this.seqmodule.action = 1;
        this.seqmodule.status = this.model.status;
        this.seqmodule.allow_days = JSON.stringify([]);
        this.seqmodule.retedata = JSON.stringify(this.model.smsassigned);

        try {
          const response = await this.seqmodule.save();
          newmoduleid = response.id;
        } catch (error) {
          // show error
          this.requestErrorAlert(error.response?.data?.error);
        }

        this.$refs.configMenu.toggleConfigMenu(false);
        selectedsms = this.model.broadcast;
        nodestatus = this.model.status === 1 ? 'Active' : 'Inactive';
        const savesms = document.querySelector(
          `#savesms${this.model.currentopennode}`
        );

        savesms.click();
        this.saveeditordata();

        this.model.broadcast = '';
        this.model.subject = '';
        this.model.smsContent = '';
        this.model.sender_id = '-1';
        this.model.smsassigned = [];

        this.hideLoader();
      } else {
        // hide loader
        this.hideLoader();

        // show error
        this.requestErrorAlert(
          this.$t(
            'frontend_groovemail_campaigns_create_select_sender_to_proceed'
          )
        );
      }
    },

    async savePostalTrigger() {
      this.showLoader();

      if (this.model.postalSequenceId) {
        try {
          this.seqmodule = new Sequencemodule({});
          this.seqmodule.sequence_id = this.$route.params.id;
          this.seqmodule.postal_sequence_id = this.model.postalSequenceId;
          this.seqmodule.postalCampaign = this.model.postalCampaign;
          this.seqmodule.node_id = this.model.currentopennode;
          this.seqmodule.type = 'postal';
          this.seqmodule.action = 1;
          this.seqmodule.status = this.model.status;
          this.seqmodule.allow_days = JSON.stringify([]);
          this.seqmodule.retedata = JSON.stringify([
            { id: this.model.postalSequenceId, name: this.model.postalCampaign }
          ]);

          const response = await this.seqmodule.save();
          newmoduleid = response.id;
        } catch (error) {
          // show error
          this.requestErrorAlert(error.response?.data?.error);

          return;
        }

        this.$refs.configMenu.toggleConfigMenu(false);
        selectedPostalCampaign = this.model.postalCampaign;
        nodestatus = this.model.status === 1 ? 'Active' : 'Inactive';
        const savePostal = document.querySelector(
          `#savepostal${this.model.currentopennode}`
        );
        savePostal.click();
        this.saveeditordata();
        this.model.postalSequenceId = '';
        this.model.postalCampaign = '';

        this.hideLoader();
      } else {
        // hide loader
        this.requestErrorAlert(
          this.$t(
            'frontend_groovemail_campaigns_create_select_campaign_to_proceed_for_postal'
          )
        );
      }
    },

    async savesplitdetail() {
      this.showLoader();
      this.seqmodule = new Sequencemodule({});
      this.seqmodule.sequence_id = this.$route.params.id;
      this.seqmodule.node_id = this.model.currentopennode;
      this.seqmodule.type = 'split';
      this.seqmodule.action = 1;
      this.seqmodule.status = this.model.status;
      this.seqmodule.allow_days = JSON.stringify([]);
      this.seqmodule.retedata = JSON.stringify(this.model.splitassigned);

      try {
        const response = await this.seqmodule.save();
        newmoduleid = response.id;
      } catch (error) {
        // show error
        this.requestErrorAlert(error.response?.data?.error);

        return;
      }

      this.$refs.configMenu.toggleConfigMenu(false);
      nodestatus = this.model.status === 1 ? 'Active' : 'Inactive';
      const savesplit = document.querySelector(
        `#savesplit${this.model.currentopennode}`
      );

      savesplit.click();
      this.saveeditordata();

      this.model.splitassigned = [];

      this.hideLoader();
    },

    async savegotodetail() {
      this.showLoader();
      this.seqmodule = new Sequencemodule({});
      this.seqmodule.sequence_id = this.$route.params.id;
      this.seqmodule.node_id = this.model.currentopennode;
      this.seqmodule.type = 'goto';
      this.seqmodule.action = 1;
      this.seqmodule.status = this.model.status;
      this.seqmodule.allow_days = JSON.stringify([]);
      this.seqmodule.retedata = JSON.stringify(this.model.gotoassigned);

      try {
        const response = await this.seqmodule.save();
        newmoduleid = response.id;
      } catch (error) {
        // show error
        this.requestErrorAlert(error.response?.data?.error);

        return;
      }
      this.$refs.configMenu.toggleConfigMenu(false);
      nodestatus = this.model.status === 1 ? 'Active' : 'Inactive';
      selectedgoto = this.model.gotostep;
      const savegoto = document.querySelector(
        `#savegoto${this.model.currentopennode}`
      );
      savegoto.click();
      this.saveeditordata();
      this.model.gotoassigned = [];
      this.hideLoader();
    },

    async savedelaydetail() {
      this.showLoader();
      this.seqmodule = new Sequencemodule({});
      this.seqmodule.sequence_id = this.$route.params.id;
      this.seqmodule.node_id = this.model.currentopennode;
      this.seqmodule.delayoption = this.model.timedelayoption;
      this.seqmodule.delaydays = +this.model.timedelaydays;
      this.seqmodule.delayhours = this.model.timedelayhours;
      this.seqmodule.delaydate =
       [3,4,5,6].includes(this.seqmodule.timedelayoption) ? this.model.timedelaydate : '';
      this.seqmodule.allow_days = JSON.stringify(this.model.delaydays);
      this.seqmodule.allow_time = this.model.timedelaytime;
      this.seqmodule.start_time = this.model.timedelaystarttime;
      this.seqmodule.end_time = this.model.timedelayendtime;
      this.seqmodule.action = this.model.segmentaction;
      this.seqmodule.type = 'delay';
      this.seqmodule.action = 1;
      this.seqmodule.status = this.model.status;
      this.seqmodule.retedata = JSON.stringify(this.model.timedelayassigned);

      try {
        const response = await this.seqmodule.save();
        newmoduleid = response.id;
      } catch (error) {
        // show error
        this.requestErrorAlert(error.response?.data?.error);

        return;
      }
      this.$refs.configMenu.toggleConfigMenu(false);
      if (this.model.timedelayoption === 1) {
        selecteddelays = 'Immediately after previous step';
      }
      if (this.model.timedelayoption === 2) {
        selecteddelays = `${this.model.timedelaydays} days and ${this.model.timedelayhours} hours`;
      }
      if (this.model.timedelayoption === 3) {
        selecteddelays = scheduledTimeInEst(this.model.timedelaydate);
      }
      if (this.model.timedelayoption === 4) {
        selecteddelays = `At dynamic date: ${this.model.timedelaydate}`;
      }
      if (this.model.timedelayoption === 5) {
        selecteddelays = `${this.model.timedelaydays} days and ${this.model.timedelayhours} hours`;
        selecteddelays += ` BEFORE dynamic date: ${this.model.timedelaydate}`;
      }
      if (this.model.timedelayoption === 6) {
        selecteddelays = `${this.model.timedelaydays} days and ${this.model.timedelayhours} hours`;
        selecteddelays += ` AFTER dynamic date: ${this.model.timedelaydate}`;
      }
      nodestatus = this.model.status === 1 ? 'Active' : 'Inactive';
      const savedelay = document.querySelector(
        `#savedelay${this.model.currentopennode}`
      );
      savedelay.click();
      this.saveeditordata();

      this.model.timedelayoption = 1;
      this.model.timedelaydays = 0;
      this.model.delaydays = [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
        'Sunday'
      ];
      this.model.timedelayhours = 0;
      this.model.timedelaydate = '';
      this.model.timedelaytime = 1;
      this.model.timedelaystarttime = '';
      this.model.timedelayendtime = '';
      this.model.timedelayassigned = [];

      this.hideLoader();
    },

    async saveemaildetail() {
      if (this.model.sender_id && this.model.sender_id !== '-1') {
        this.showLoader();

        try {
          this.seqmodule = new Sequencemodule({});
          this.seqmodule.sequence_id = this.$route.params.id;
          this.seqmodule.broadcast = this.model.broadcast;
          this.seqmodule.senderemail = this.model.senderemail;
          this.seqmodule.sendername = this.model.sendername;
          this.seqmodule.sender_id = this.model.sender_id;
          this.seqmodule.replyemail = this.model.replyemail;
          this.seqmodule.subject = this.model.subject;
          this.seqmodule.previewtext = this.model.previewtext;
          this.seqmodule.editor_type = this.model.editor_type;
          this.seqmodule.content = this.model.content;
          this.seqmodule.emailContentSections = this.model.emailContentSections
            ? typeof this.model.emailContentSections === 'string'
              ? this.model.emailContentSections
              : JSON.stringify(this.model.emailContentSections)
            : '';
          // if (this.model.email_id) {
          this.seqmodule.email_id = this.model.email_id;
          // }
          if (this.model.template_name) {
            this.seqmodule.template_name = this.model.template_name;
          }
          if (this.model.template_folder) {
            this.seqmodule.template_subcategory_id = this.model.template_folder;
          }
          this.seqmodule.node_id = this.model.currentopennode;
          this.seqmodule.type = 'email';
          this.seqmodule.action = 1;
          this.seqmodule.status = this.model.status;
          this.seqmodule.allow_days = JSON.stringify([]);
          this.seqmodule.retedata = JSON.stringify(this.model.emailassigned);

          const response = await this.seqmodule.save();
          newmoduleid = response.id;
        } catch (error) {
          // show error alert
          this.requestErrorAlert(error.response?.data?.error);

          return;
        }

        this.$refs.configMenu.toggleConfigMenu(false);
        selectedemails = this.model.broadcast;
        nodestatus = this.model.status === 1 ? 'Active' : 'Inactive';
        const saveemail = document.querySelector(
          `#saveemail${this.model.currentopennode}`
        );
        saveemail.click();
        this.saveeditordata();

        this.model.broadcast = '';
        this.model.senderemail = '';
        this.model.sendername = '';
        this.model.replyemail = '';
        this.model.subject = '';
        this.model.previewtext = '';
        this.model.content = '';
        this.model.editor_type = 3;
        this.model.emailContentSections = '';
        this.model.email_id = null;
        this.model.template_name = '';
        this.model.template_folder = null;
        this.model.sender_id = '-1';
        this.model.emailassigned = [];

        this.hideLoader();
      } else {
        // show error alert
        this.requestErrorAlert(
          this.$t(
            'frontend_groovemail_campaigns_create_select_sender_to_proceed'
          )
        );
      }
    },

    delnode() {
      this.$refs.configMenu.toggleConfigMenu(false);
    },

    delcontrol() {
      const delenode = document.querySelector('#delcontrolbtn');
      if (delenode.dataset.name === 'list') {
        this.model.subscribedlists = [];
        listnodecount = 0;
      } else if (delenode.dataset.name === 'tag') {
        this.model.assignedtags = [];
        tagnodecount = 0;
      } else if (delenode.dataset.name === 'form') {
        this.model.subscribedforms = [];
        formnodecount = 0;
      }
      const saverule = document.querySelector('#saverule');
      saverule.click();
      this.saveeditordata();
    },

    deletetag(option) {
      const index = this.model.assignedtags.indexOf(option);
      this.model.assignedtags.splice(index, 1);
      const updaterule = document.querySelector('#updaterule');
      updaterule.click();
    },

    deletelist(option) {
      const index = this.model.subscribedlists.indexOf(option);
      this.model.subscribedlists.splice(index, 1);

      const updaterule = document.querySelector('#updaterule');
      updaterule.click();
    },

    async openNewRule() {
      this.showLoader();
      try {
        this.$refs.configMenu.toggleConfigMenu(false);
        const mailsequence = await Mailsequence.$find(this.$route.params.id);
        this.model.subscribedforms = mailsequence.startruleforms;
        this.model.subscribedlists = mailsequence.startrulelists;
        this.model.assignedtags = mailsequence.startruletags;
      } catch (error) {
        // show error alert
        this.requestErrorAlert(error.response?.data?.error);

        return;
      }

      this.$refs.configMenu.toggleConfigMenu(true);
      this.$refs.configMenu.seqAction = {
        type: 'saverule',
        value: 1
      };

      this.$refs.configMenu.title = `${this.$t(
        'frontend_groovemail_sequence_configure'
      )} "Starting Rule"`;

      setTimeout(() => {
        const addrule = document.querySelector('#addrule');
        if (addrule && addrule.dataset && addrule.dataset.editEleType) {
          this.$refs.configMenu.updateTabForStartRule(
            addrule.dataset.editEleType
          );
        }
      }, 100);
      this.hideLoader();
    },

    openNewTag() {
      this.$root.$emit('modal-open', 'createtag-model');
    },

    openNewList() {
      this.$root.$emit('modal-open', 'createlist-model');
    },

    async openviewdetail() {
      const viewdetail = document.querySelector('#viewdetailbtn');
      const { moduleid } = viewdetail.dataset;
      this.showLoader();
      this.model.viewmoduledetail = await Sequencemodule.$find(moduleid);
      this.hideLoader();
    },

    async activeNode() {
      this.showLoader();
      const activeStatus = document.querySelector('#activatenodebtn');
      const { moduleid } = activeStatus.dataset;
      const { nodeid } = activeStatus.dataset;
      const status = activeStatus.dataset.nodestatus;

      try {
        this.sequencemodule = await Sequencemodule.$find(moduleid);
        this.sequencemodule.status = status === 'true' ? 1 : 0;

        const response = await this.sequencemodule.save();
        this.model.viewmoduledetail = response;
      } catch (error) {
        // show error message
        this.requestErrorAlert(error.response?.data?.error);

        return;
      }
      nodestatus = status === 'true' ? 'Active' : 'Inactive';
      const updatestatus = document.querySelector(`#updatestatus${nodeid}`);
      updatestatus.click();
      this.saveeditordata();
      this.hideLoader();
    },

    async openeditdetail() {
      this.$refs.configMenu.toggleConfigMenu(false);
      const editdetail = document.querySelector('#editdetailbtn');
      if (editdetail.dataset.moduleid) {
        const { moduleid } = editdetail.dataset;
        this.model.currentopennode = editdetail.dataset.nodeid;
        this.showLoader();
        this.model.viewmoduledetail = await Sequencemodule.$find(moduleid);
        const moduledetail = this.model.viewmoduledetail;
        this.model.editstep = moduledetail.step;
        this.model.edittype = moduledetail.type;
        this.model.timedelayoption = moduledetail.delayoption;
        this.model.timedelaydays = moduledetail.delaydays;
        this.model.timedelayhours = moduledetail.delayhours;
        this.model.timedelaydate = moduledetail.delaydate;
        if (moduledetail.delayoption === 3) {
          this.model.timedelaydate = moduledetail.delaydate
            ? moment.utc(moduledetail.delaydate).toISOString()
            : new Date().toISOString();
        }
        this.model.editallowdays = JSON.parse(moduledetail.allow_days);
        this.model.editallowtime = moduledetail.allow_time;
        this.model.editstarttime = moduledetail.start_time;
        this.model.editendtime = moduledetail.end_time;
        this.model.broadcast = moduledetail.broadcast;
        this.model.sendername = moduledetail.sendername;
        this.model.sender_id = moduledetail.sender_id;
        this.model.senderemail = moduledetail.senderemail;
        this.model.replyemail = moduledetail.replyemail;
        this.model.subject = moduledetail.subject;
        this.model.previewtext = moduledetail.previewtext;
        this.model.editor_type = moduledetail.editor_type
          ? moduledetail.editor_type
          : 3;
        this.model.postalSequenceId = moduledetail.postal_sequence_id;
        this.model.postalCampaign = moduledetail.postalCampaign;
        if (moduledetail.type === 'email') {
          if (moduledetail.email_id) {
            this.model.editor_type = 3;
            this.model.email_id = moduledetail.email_id;
            await this.fetchTemplateData(this.model.email_id);
          } else {
            this.model.content = moduledetail.content;
            this.model.smsContent = '';
            const emailSections = moduledetail.emailContentSections
              ? JSON.parse(moduledetail.emailContentSections)
              : '';
            this.model.emailContentSections = emailSections || '';
          }
        } else if (moduledetail.type === 'sms') {
          this.model.smsContent = moduledetail.content;
          this.model.content = '';
          this.model.emailContentSections = '';
        } else {
          this.model.editor_type = 3;
          this.model.content = '';
          this.model.smsContent = '';
          this.model.emailContentSections = '';
          this.model.email_id = null;
          this.model.template_name = '';
          this.model.template_folder = null;
        }
        this.model.editaction = moduledetail.action;
        this.model.editassigned = JSON.parse(moduledetail.retedata);
        this.model.status = moduledetail.status;
        this.hideLoader();
        this.$refs.configMenu.toggleConfigMenu(true);
        this.$refs.configMenu.seqAction = {
          type: 'editdetail',
          value: 1
        };
        let actionToEdit = '';
        if (moduledetail.type === 'tag') {
          if (moduledetail.action === 1) {
            actionToEdit = 'Add Tag';
          } else if (moduledetail.action === 2) {
            actionToEdit = 'Remove Tag';
          }
        } else if (moduledetail.type === 'list') {
          if (moduledetail.action === 1) {
            actionToEdit = 'Subscribe To List';
          } else if (moduledetail.action === 2) {
            actionToEdit = 'Unsubscribe From List';
          }
        } else if (moduledetail.type === 'email') {
          actionToEdit = 'Send Email';
        } else if (moduledetail.type === 'sms') {
          actionToEdit = 'Send SMS';
        } else if (moduledetail.type === 'delay') {
          actionToEdit = 'Time Delay';
        } else if (moduledetail.type === 'split') {
          actionToEdit = 'Conditional Split';
        } else if (moduledetail.type === 'goto') {
          actionToEdit = 'Goto';
        } else if (moduledetail.type === 'postal') {
          actionToEdit = 'Send Postcards';
        }
        this.$refs.configMenu.title = `${this.$t(
          'frontend_edit'
        )} "${actionToEdit}" ${this.$t(
          'frontend_groovemail_sequences_actions_text'
        )}`;
      } else {
        if (
          editdetail.dataset.nodename === 'Add Tag' ||
          editdetail.dataset.nodename === 'Remove Tag'
        ) {
          this.model.edittype = 'tag';
        } else if (
          editdetail.dataset.nodename === 'Subscribe To List' ||
          editdetail.dataset.nodename === 'Unsubscribe From List'
        ) {
          this.model.edittype = 'list';
        } else if (editdetail.dataset.nodename === 'Send Email') {
          this.model.edittype = 'email';
        } else if (editdetail.dataset.nodename === 'Time Delay') {
          this.model.edittype = 'delay';
        } else if (editdetail.dataset.nodename === 'Send SMS') {
          this.model.edittype = 'sms';
        } else if (editdetail.dataset.nodename === 'Automation') {
          this.model.edittype = 'automation';
        } else if (editdetail.dataset.nodename === 'Conditional Split') {
          this.model.edittype = 'split';
        } else if (editdetail.dataset.nodename === 'Goto') {
          this.model.edittype = 'goto';
        } else if (editdetail.dataset.nodename === 'Send Postcards') {
          this.model.edittype = 'postal';
        }
        this.openTriggerMenu(
          editdetail.dataset.nodeid,
          editdetail.dataset.nodename
        );
      }
    },

    async fetchTemplateData(id) {
      this.showLoader();
      try {
        const templateData = await axios.get(`email/template/${id}`);
        this.hideLoader();
        this.assignTemplateDataInBuilder(templateData);
      } catch (err) {
        this.hideLoader();
      }
    },

    assignTemplateDataInBuilder(templateData) {
      if (templateData && templateData.data) {
        this.model.template_name = templateData.data.name || '';
        this.model.template_folder = templateData.data.category_id || null;
        this.model.content = templateData.data.message || '';
        this.model.smsContent = '';
        const emailSections = templateData.data.emailContentSections
          ? JSON.parse(templateData.data.emailContentSections)
          : '';
        this.model.emailContentSections = emailSections || '';
      }
    },

    closeeditdetail() {
      this.$root.$emit('modal-close', 'editdetail-model');
    },

    closeviewdetail() {
      this.$root.$emit('modal-close', 'viewdetail-model');
    },

    closestartmodel() {
      this.$root.$emit('modal-close', 'startrule-model');
    },

    closetagmodel() {
      const deletenode = document.querySelector(
        `#deletenode${this.model.currentopennode}`
      );
      deletenode.click();
      this.$root.$emit('modal-close', 'createtag-model');
    },

    closelistmodel() {
      const deletenode = document.querySelector(
        `#deletenode${this.model.currentopennode}`
      );
      deletenode.click();
      this.$root.$emit('modal-close', 'createlist-model');
    },

    fetchClosemIntegeration() {
      const user = auth.authenticatedUser();
      let integrations = [];
      if (user.metadata && user.metadata.integrations) {
        integrations = user.metadata.integrations.filter(
          ele => ele.type === 'closem-integration'
        );
      }
      return integrations;
    },

    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },

    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },

    // error message for the request field
    async requestErrorAlert(error) {
      // hide the loader
      this.hideLoader();

      await showAlert({
        iconType: 'alert-error',
        html: `
          <style>.swal2-cancel { color: ${
            themeConfig.appPrimaryColorInvert
          } !important; }</style>
          <p class="text-sm text-deep-dark mb-3">${error ||
            this.$t('frontend_backend_error')}</p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: this.$t('frontend_close')
      });
    }
  }
};

class StartControl extends Rete.Control {
  constructor(emitter, key, readonly, type = 'text') {
    if (document.querySelector('.conditional-split')) {
      document.querySelector('.conditional-split').innerHTML = `
        <p class="logic-header text-secondary-invert">
          ${i18n.t('frontend_groovemail_sequence_logic_header')}
        </p>
        <p class="node-title title">Conditional Split</p>
      `;
    }

    if (document.querySelector('.time-delay')) {
      document.querySelector('.time-delay').innerHTML = `
        <p class="timing-header text-secondary-invert">
          ${i18n.t('frontend_groovemail_sequence_timing_header')}
        </p>
        <p class="node-title title">Time Delay</p>
      `;
    }

    if (document.querySelector('.send-email')) {
      document.querySelector('.send-email').innerHTML = `
        <p class="timing-header text-secondary-invert">
          ${i18n.t('frontend_groovemail_sequence_actions_header')}
        </p>
        <p class="node-title title">Send Email</p>
      `;
    }

    super(key);
    this.emitter = emitter;
    this.key = key;
    this.type = type;
    this.keyz = 0;
    this.props = {};
    this.template = '';
    i18n.locale = localStorage.lang;

    this.template += `
    <div class="control-main-header border-b border-grey-300">
      <span class="control-header-title text-grey-800" @dblclick.stop="" @pointerdown.stop="" @pointermove.stop="" @click="edit_btn($event, 'tag')" title="Click to configure">
        Triggers
      </span>
    </div>

    <div class="flex flex-row flex-wrap content-end justify-center py-4">
      <div class="w-20 h-20 dropdown mx-2 px-2 py-4 border border-grey-300 btn-radius relative" style="display:{{tagdisplay}}">
        <span class="w-4 h-4 bg-primary rounded-full text-primary-invert text-xs font-bold leading-4 modulecount">
          {{tagcount}}
        </span>
        <button class="moduleicon dropbtn tag-icon"></button>
        <p class="text-grey-700 text-xs mt-2">
          ${i18n.t('frontend_groovemail_sequence_tags')}
        </p>
        <div class="text-left dropdown-content">
          <a class="hover:text-primary" @click="edit_btn($event, 'tag')">
            ${i18n.t('frontend_edit')}
          </a>
          <a class="hover:text-primary" @click="del_btn($event)" data-name="tag">
            ${i18n.t('frontend_remove')}
          </a>
        </div>
      </div>

      <div class="w-20 h-20 dropdown mx-2 px-2 py-4 border border-grey-300 btn-radius relative" style="display:{{listdisplay}}">
        <span class="w-4 h-4 bg-primary rounded-full text-primary-invert text-xs font-bold leading-4 modulecount">
          {{listcount}}
        </span>
        <button class="moduleicon dropbtn list-icon"></button>
        <p class="text-grey-700 text-xs mt-2">${i18n.t(
          'frontend_groovemail_sequence_lists'
        )}</p>
        <div class="text-left dropdown-content">
          <a class="hover:text-primary" @click="edit_btn($event, 'list')">
            ${i18n.t('frontend_edit')}
          </a>
          <a class="hover:text-primary" @click="del_btn($event)" data-name="list">
            ${i18n.t('frontend_remove')}
          </a>
        </div>
      </div>

      <div class="w-20 h-20 dropdown mx-2 px-2 py-4 border border-grey-300 btn-radius relative" style="display:{{formdisplay}}">
        <span class="w-4 h-4 bg-primary rounded-full text-primary-invert text-xs font-bold leading-4 modulecount">
          {{formcount}}
        </span>
        <button class="moduleicon dropbtn form-icon"></button>
        <p class="text-grey-700 text-xs mt-2">
          ${i18n.t('frontend_groovemail_sequence_forms')}
        </p>
        <div class="text-left dropdown-content">
          <a class="hover:text-primary" @click="edit_btn($event, 'form')">
            ${i18n.t('frontend_edit')}
          </a>
          <a class="hover:text-primary" @click="del_btn($event)" data-name="form">
            ${i18n.t('frontend_remove')}
          </a>
        </div>
      </div>

      <div class="w-full flex justify-center mt-5">
        <button @click="addrule($event, 'tag')" id="startmodule" class="relative flex flex-col items-center startmodule">
          <span class="plus-round-icon bg-primary border-primary rounded"></span>
          <p class="text-grey-700 text-xs mt-2">${i18n.t(
            'frontend_groovemail_sequence_add_trigger'
          )}</p>
        </button>
      </div>
      <button @click="saverule($event)" id="saverule" style="display:none">-</button>
      <button @click="changeview($event)" id="changeview" style="display:none;">-</button>
    </div>`;

    this.scope = {
      tagdisplay: 'none',
      listdisplay: 'none',
      formdisplay: 'none',
      value: null,
      readonly,
      tagcount: 0,
      listcount: 0,
      formcount: 0,
      addrule: this.addrule.bind(this),
      saverule: this.saverule.bind(this),
      del_btn: this.del_btn.bind(this),
      updaterule: this.updaterule.bind(this),
      edit_btn: this.edit_btn.bind(this),
      changeview: this.changeview.bind(this)
    };
  }

  addrule(e, type) {
    const addrule = document.querySelector('#addrule');
    addrule.setAttribute('data-edit-ele-type', type);
    addrule.click();
  }

  changeview() {
    if (viewtype === 'vertical') {
      for (let i = 0; i < this.emitter.nodes.length; i += 1) {
        if (i === 0) {
          this.emitter.nodes[i].position = [500, 100];
        } else if (i === 1) {
          this.emitter.nodes[i].position = [
            500,
            this.emitter.nodes[i - 1].position[1] + 350
          ];
        } else {
          this.emitter.nodes[i].position = [
            500,
            this.emitter.nodes[i - 1].position[1] + 250
          ];
        }
      }
    } else {
      for (let i = 0; i < this.emitter.nodes.length; i += 1) {
        if (i === 0) {
          this.emitter.nodes[i].position = [300, 200];
        } else {
          this.emitter.nodes[i].position = [
            this.emitter.nodes[i - 1].position[0] + 450,
            250
          ];
        }
      }
    }
    this.emitter.trigger('process');
    this._alight.scan();
  }

  saverule() {
    if (tagnodecount >= 0) {
      this.scope.tagdisplay = 'block';
    }

    if (listnodecount >= 0) {
      this.scope.listdisplay = 'block';
    }

    if (formnodecount >= 0) {
      this.scope.formdisplay = 'block';
    }

    const node = this.getNode();
    this.scope.tagcount = node.data.tagcount = tagnodecount;
    this.scope.listcount = node.data.listcount = listnodecount;
    this.scope.formcount = node.data.formcount = formnodecount;

    this.emitter.trigger('process');
    this._alight.scan();
  }

  edit_btn(e, type) {
    const addrule = document.querySelector('#addrule');
    addrule.setAttribute('data-edit-ele-type', type);
    addrule.click();
  }

  del_btn(e) {
    const delcontrolbtn = document.querySelector('#delcontrolbtn');
    delcontrolbtn.setAttribute('data-name', e.target.dataset.name);
    delcontrolbtn.click();

    if (e.target.dataset.name === 'tag') {
      this.scope.tagdisplay = 'none';
    }

    if (e.target.dataset.name === 'list') {
      this.scope.listdisplay = 'none';
    }

    if (e.target.dataset.name === 'form') {
      this.scope.formdisplay = 'none';
    }

    this.update();
  }

  updaterule() {
    this.scope.tagcount = tagnodecount;
    this.scope.listcount = listnodecount;

    this.emitter.trigger('process');
    this._alight.scan();

    this.update();
  }

  update() {
    this.putData(this.emitter, this.key, newstartrule);
    this.emitter.trigger('process');
    this._alight.scan();
  }

  mounted() {
    if (this.getNode().data.tagcount > 0) {
      this.scope.tagcount = tagnodecount = this.getNode().data.tagcount;
      this.scope.tagdisplay = 'block';
    }

    if (this.getNode().data.listcount > 0) {
      this.scope.listcount = listnodecount = this.getNode().data.listcount;
      this.scope.listdisplay = 'block';
    }

    if (this.getNode().data.formcount > 0) {
      this.scope.formcount = formnodecount = this.getNode().data.formcount;
      this.scope.formdisplay = 'block';
    }

    this.emitter.trigger('process');
    this._alight.scan();
  }
}

class StartComponent extends Rete.Component {
  constructor() {
    super('Triggers');
    this.module = {
      nodeType: 'module'
    };
    this.render = 'vue';
    this.data.props = {};
  }

  builder(node) {
    const ctrl = new StartControl(this.editor, 'module');
    const indot = new Rete.Input('startInput', '', anyTypeSocket, false);
    const out = new Rete.Output('startOutput', '', anyTypeSocket, false);

    ctrl.onChange = () => {
      this.updateModuleSockets(node);
      node._alight.scan();
    };

    return node
      .addControl(ctrl)
      .addOutput(out)
      .addInput(indot);
  }

  change() {
    this.editor.trigger('process');
    this.getNode()._alight.scan();
  }
}

class SendSMSControl extends Rete.Control {
  constructor(emitter, key, readonly, type = 'text') {
    super(key);
    this.emitter = emitter;
    this.key = key;
    this.type = type;
    this.props = {};
    this.keyz = 0;
    this.id = Math.random()
      .toString(36)
      .substr(2, 9);
    i18n.locale = localStorage.lang;
    this.template = `<div class="control-main-header">
        <span class="control-header-title text-grey-800" @click="editsms($event)" @dblclick.stop="" @pointerdown.stop="" @pointermove.stop="" title="Click to configure">
          Send SMS
        </span>
      </div>
      <button @click="savesms($event)" id="savesms{{id}}" class="savesms" style="display:none;">-</button>
      <button @click="updatemodule($event)" id="updatemodule{{id}}" class="updatemodule" style="display:none;">-</button>
      <button @click="updatestatus($event)" id="updatestatus{{id}}" class="updatestatus" style="display:none;">-</button>
    `;

    this.template += `<div class="dropdown mt-2 mr-4 pull-right">
        <button class="dropbtn"></button>
        <div class="text-left dropdown-content">
          <a class="hover:text-primary" @click="editsms($event)">
            ${i18n.t('frontend_edit')}
          </a>
          <a class="hover:text-primary" @click="deletenode($event)" id="deletenode{{id}}">
            ${i18n.t('frontend_remove')}
          </a>
        </div>
      </div>

      <div class="outputDisplay text-sm ">
        <p class="broadcast-header">{{selectedsms}}</p>
        <input id="smsToggle-{{id}}" type="checkbox" class="cm-toggle {{checked}}" @change="activateSmsNode($event)" :checked="checked" @dblclick.stop="" @pointerdown.stop="" @pointermove.stop=""/>
        <span class="text-sm activeState">
          {{status}}
        </span>
      </div>
    `;

    this.scope = {
      value: null,
      readonly,
      id: null,
      selectedsms: '',
      moduleid: '',
      status: '',
      checked: '',
      isNodeConfigured: false,
      savesms: this.savesms.bind(this),
      editsms: this.editsms.bind(this),
      activateSmsNode: this.activateSmsNode.bind(this),
      deletenode: this.deletenode.bind(this),
      viewdetail: this.viewdetail.bind(this),
      updatemodule: this.updatemodule.bind(this),
      updatestatus: this.updatemodule.bind(this)
    };
  }

  async deletenode() {
    // set the target node
    targetNode = this.getNode();

    // open the confirmation modal to delete the node
    self.$refs[`confirmation-delete`].open();
  }

  editsms() {
    const node = this.getNode();
    const editdetailbtn = document.querySelector('#editdetailbtn');
    editdetailbtn.setAttribute('data-moduleid', this.scope.moduleid);
    editdetailbtn.setAttribute('data-nodeid', node.id);
    editdetailbtn.setAttribute('data-nodename', node.name);
    editdetailbtn.click();
  }

  activateSmsNode(e) {
    if (this.scope.isNodeConfigured) {
      const all = document.getElementsByClassName('send-sms');
      if (e.target.checked) {
        if (all.length) {
          if (all[0]) all[0].style.background = '#fff';
          if (all[1]) all[1].style.background = '#fff';
        }
      } else if (all.length) {
        if (all[0]) all[0].style.background = '#f7f7fa';
        if (all[1]) all[1].style.background = '#f7f7fa';
      }
      const node = this.getNode();
      const activatebtn = document.querySelector('#activatenodebtn');
      if (this.scope.moduleid) {
        activatebtn.setAttribute('data-moduleid', this.scope.moduleid);
      }
      activatebtn.setAttribute('data-nodeid', node.id);
      activatebtn.setAttribute('data-nodestatus', e.target.checked);
      activatebtn.click();
    } else {
      i18n.locale = localStorage.lang;
      showAlert({
        iconType: 'alert-error',
        html: `
          <style>.swal2-confirm { color: ${
            themeConfig.appPrimaryColorInvert
          } !important; }</style>
          <p class="text-sm text-deep-dark"> ${i18n.t(
            'frontend_groovemail_sequence_configure_sms_node'
          )}</p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: i18n.t('frontend_close')
      });
      const smsToggle = document.getElementById(`smsToggle-${this.scope.id}`);
      smsToggle.checked = false;
    }
  }

  viewdetail() {
    const node = this.getNode();
    const viewdetailbtn = document.querySelector('#viewdetailbtn');
    viewdetailbtn.setAttribute('data-node_id', node.id);
    viewdetailbtn.setAttribute('data-moduleid', this.scope.moduleid);
    viewdetailbtn.click();
  }

  updatemodule() {
    const node = this.getNode();
    this.scope.selectedsms = node.data.selectedsms = selectedsms;
    this.scope.status = node.data.status = nodestatus;
    this.scope.checked = nodestatus === 'Active' ? 'checked' : '';
    this.emitter.trigger('process');
    this._alight.scan();
  }

  updatestatus() {
    const node = this.getNode();
    this.scope.status = node.data.status = nodestatus;
    this.scope.checked = nodestatus === 'Active' ? 'checked' : '';
    this.emitter.trigger('process');
    this._alight.scan();
  }

  savesms() {
    const node = this.getNode();

    this.scope.selectedsms = node.data.selectedsms = selectedsms;
    this.scope.moduleid = node.data.moduleid = newmoduleid;
    this.scope.status = node.data.status = nodestatus;
    this.scope.checked = nodestatus === 'Active' ? 'checked' : '';
    this.update();

    this.emitter.trigger('process');
    this._alight.scan();
  }

  update() {
    const all = document.getElementsByClassName('selected send-sms');
    if (all.length) {
      if (all[0]) all[0].style.background = '#f7f7fa';
      if (all[1]) all[1].style.background = '#f7f7fa';
    }

    if ((this.getNode(), this.getNode().data && this.getNode().data.moduleid)) {
      this.scope.isNodeConfigured = true;
    }
  }

  mounted() {
    this.scope.selectedsms = '';
    this.scope.id = this.getNode().id;
    if ((this.getNode(), this.getNode().data && this.getNode().data.moduleid)) {
      this.scope.isNodeConfigured = true;
    }

    if (this.getNode().data.selectedsms) {
      this.scope.selectedsms = this.getNode().data.selectedsms;
    }

    if (this.getNode().data.moduleid) {
      this.scope.moduleid = this.getNode().data.moduleid;
    }

    if (this.getNode().data.status) {
      this.scope.status = this.getNode().data.status;
      this.scope.checked =
        this.getNode().data.status === 'Active' ? 'checked' : '';
    }

    this.emitter.trigger('process');
    this._alight.scan();
  }
}

class SendSMSComponent extends Rete.Component {
  constructor() {
    super('Send SMS');
    this.module = {
      nodeType: 'module'
    };
    this.render = 'vue';
    this.data.props = {};
  }

  builder(node) {
    const ctrl = new SendSMSControl(this.editor, 'module');
    const indot = new Rete.Input('sendsmsInput', '', anyTypeSocket, false);
    const out = new Rete.Output('sendsmsOutput', '', anyTypeSocket, false);

    ctrl.onChange = () => {
      this.updateModuleSockets(node);
      node._alight.scan();
    };
    return node
      .addControl(ctrl)
      .addOutput(out)
      .addInput(indot);
  }
}

// class GotoComponent extends Rete.Component {
//   constructor() {
//     super('Goto');
//     this.module = {
//       nodeType: 'module',
//     };
//     this.render = 'vue';
//     this.data.props = {};
//   }

//   builder(node) {
//     const ctrl = new GotoControl(this.editor, 'module');
//     const indot = new Rete.Input('gotoInput', '', anyTypeSocket, false);
//     const out = new Rete.Output('gotoOutput', '', anyTypeSocket, false);

//     ctrl.onChange = () => {
//       this.updateModuleSockets(node);
//       node._alight.scan();
//     };
//     return node.addControl(ctrl).addOutput(out).addInput(indot);
//   }
// }

// class GotoControl extends Rete.Control {
//   constructor(emitter, key, readonly, type = 'text') {
//     super(key);
//     this.emitter = emitter;
//     this.key = key;
//     this.type = type;
//     this.props = {};
//     this.keyz = 0;
//     this.id = Math.random().toString(36).substr(2, 9);
//     i18n.locale = localStorage.lang;
//     this.template =
//       '<div class="control-main-header"><span class="control-header-title text-grey-800" @click="editgoto($event)" @dblclick.stop="" @pointerdown.stop="" @pointermove.stop="" title="Click to configure"> Goto</span></div><button @click="savegoto($event)" id="savegoto{{id}}" class="savegoto" style="display:none;">-</button><button @click="updatemodule($event)" id="updatemodule{{id}}" class="updatemodule" style="display:none;">-</button><button @click="updatestatus($event)" id="updatestatus{{id}}" class="updatestatus" style="display:none;">-</button>';

//     this.template += `<div class="dropdown mt-2 mr-4 pull-right"><button class="dropbtn"></button><div class="text-left dropdown-content"><a class="hover:text-primary" @click="editgoto($event)">${i18n.t(
//       'frontend_edit'
//     )}</a><a class="hover:text-primary" @click="deletenode($event)" id="deletenode{{id}}">${i18n.t(
//       'frontend_remove'
//     )}</a></div></div><div class="outputDisplay text-sm "><p class="broadcast-header">Step {{selectedgoto}}</p><input id="gotoToggle-{{id}}" type="checkbox" class="cm-toggle {{checked}}" @change="activateGotoNode($event)" :checked="checked" @dblclick.stop="" @pointerdown.stop="" @pointermove.stop=""/><span class="text-sm activeState">{{status}}</span></div>`;

//     this.scope = {
//       value: null,
//       readonly,
//       id: null,
//       status: '',
//       checked: '',
//       selectedgoto: '',
//       moduleid: '',
//       isNodeConfigured: false,
//       savegoto: this.savegoto.bind(this),
//       editgoto: this.editgoto.bind(this),
//       deletenode: this.deletenode.bind(this),
//       activateGotoNode: this.activateGotoNode.bind(this),
//       viewdetail: this.viewdetail.bind(this),
//       updatemodule: this.updatemodule.bind(this),
//     };
//   }

//   async deletenode(e) {
// // set the target node
// targetNode = this.getNode();

// // open the confirmation modal to delete the node
// self.$refs[`confirmation-delete`].open();
//   }

//   editgoto(e) {
//     const node = this.getNode();
//     const editdetailbtn = document.querySelector('#editdetailbtn');
//     editdetailbtn.setAttribute('data-moduleid', this.scope.moduleid);
//     editdetailbtn.setAttribute('data-nodeid', node.id);
//     editdetailbtn.setAttribute('data-nodename', node.name);
//     editdetailbtn.click();
//   }

//   activateGotoNode(e) {
//     if (this.scope.isNodeConfigured) {
//       const all = document.getElementsByClassName('goto');
//       if (e.target.checked) {
//         if (all.length) {
//           if (all[0]) all[0].style.background = '#fff';
//           if (all[1]) all[1].style.background = '#fff';
//         }
//       } else if (all.length) {
//           if (all[0]) all[0].style.background = '#f7f7fa';
//           if (all[1]) all[1].style.background = '#f7f7fa';
//         }
//       const node = this.getNode();
//       const activatebtn = document.querySelector('#activatenodebtn');
//       if (this.scope.moduleid) {
//         activatebtn.setAttribute('data-moduleid', this.scope.moduleid);
//       }
//       activatebtn.setAttribute('data-nodeid', node.id);
//       activatebtn.setAttribute('data-nodestatus', e.target.checked);
//       activatebtn.click();
//     } else {
//       i18n.locale = localStorage.lang;
//       showAlert({
//         iconType: 'alert-error',
//         html : `<p class="text-sm text-deep-dark"> ${ i18n.t('frontend_groovemail_sequence_configure_goto_node') }</p>`,
//         showCancelButton: false,
//         showCloseButton: true,
//         confirmButtonColor: '#fd6481',
//         confirmButtonText: i18n.t(
//           'frontend_close'
//         ),
//       });
//       const gotoToggle = document.getElementById(`gotoToggle-${this.scope.id}`);
//       gotoToggle.checked = false;
//     }
//   }

//   viewdetail(e) {
//     const node = this.getNode();
//     const viewdetailbtn = document.querySelector('#viewdetailbtn');
//     viewdetailbtn.setAttribute('data-node_id', node.id);
//     viewdetailbtn.setAttribute('data-moduleid', this.scope.moduleid);
//     viewdetailbtn.click();
//   }

//   updatemodule(e) {
//     const node = this.getNode();
//     this.scope.selectedgoto = node.data.selectedgoto = selectedgoto;
//     this.scope.status = node.data.status = nodestatus;
//     this.scope.checked = nodestatus == 'Active' ? 'checked' : '';
//     this._alight.scan();
//   }

//   updatestatus(e) {
//     const node = this.getNode();
//     this.scope.status = node.data.status = nodestatus;
//     this.scope.checked = nodestatus == 'Active' ? 'checked' : '';
//     this.emitter.trigger('process');
//     this._alight.scan();
//   }

//   savegoto(e) {
//     const node = this.getNode();

//     this.scope.selectedgoto = node.data.selectedgoto = selectedgoto;
//     this.scope.moduleid = node.data.moduleid = newmoduleid;
//     this.scope.status = node.data.status = nodestatus;
//     this.scope.checked = nodestatus == 'Active' ? 'checked' : '';
//     this.update();

//     this.emitter.trigger('process');
//     this._alight.scan();
//   }

//   update() {
//     if ((this.getNode(), this.getNode().data && this.getNode().data.moduleid)) {
//       this.scope.isNodeConfigured = true;
//     }
//   }

//   mounted() {
//     this.scope.selectedgoto = '';
//     this.scope.id = this.getNode().id;
//     if ((this.getNode(), this.getNode().data && this.getNode().data.moduleid)) {
//       this.scope.isNodeConfigured = true;
//     }

//     if (this.getNode().data.selectedgoto) {
//       this.scope.selectedgoto = this.getNode().data.selectedgoto;
//     }

//     if (this.getNode().data.moduleid) {
//       this.scope.moduleid = this.getNode().data.moduleid;
//     }

//     if (this.getNode().data.status) {
//       this.scope.status = this.getNode().data.status;
//       this.scope.checked =
//         this.getNode().data.status == 'Active' ? 'checked' : '';
//     }

//     this.emitter.trigger('process');
//     this._alight.scan();
//   }
// }

class TagControl extends Rete.Control {
  constructor(emitter, key, readonly, type = 'text', tagNodeType) {
    super(key);
    this.emitter = emitter;
    this.key = key;
    this.type = type;
    this.props = {};
    this.keyz = 0;
    this.tagNodeType = tagNodeType;
    this.id = Math.random()
      .toString(36)
      .substr(2, 9);
    i18n.locale = localStorage.lang;

    this.template = `<div class="control-main-header"><span class="control-header-title text-grey-800" @click="edittag($event)" @dblclick.stop="" @pointerdown.stop="" @pointermove.stop="" title="Click to configure"> ${tagNodeType} </span></div><button @click="savetag($event)" id="savetag{{id}}" class="savetag" style="display:none;">-</button><button @click="updatemodule($event)" id="updatemodule{{id}}" class="updatemodule" style="display:none;">-</button><button @click="updatestatus($event)" id="updatestatus{{id}}" class="updatestatus" style="display:none;">-</button>`;

    this.template += `<div class="dropdown mt-2 mr-4 pull-right"><button class="dropbtn"></button><div class="text-left dropdown-content"><a class="hover:text-primary" @click="edittag($event)">${i18n.t(
      'frontend_edit'
    )}</a><a class="hover:text-primary" @click="deletenode($event)" id="deletenode{{id}}">${i18n.t(
      'frontend_remove'
    )}</a></div></div><div class="outputDisplay text-sm "><p class="broadcast-header">{{selectedtags}}</p><input id="tagToggle-{{id}}" type="checkbox" class="cm-toggle {{checked}}" @change="activateTagNode($event)" :checked="checked" @dblclick.stop="" @pointerdown.stop="" @pointermove.stop=""/><span class="text-sm activeState">{{status}}</span></div>`;

    this.scope = {
      value: null,
      readonly,
      id: null,
      selectedtags: '',
      moduleid: '',
      status: '',
      checked: '',
      isNodeConfigured: false,
      savetag: this.savetag.bind(this),
      edittag: this.edittag.bind(this),
      activateTagNode: this.activateTagNode.bind(this),
      deletenode: this.deletenode.bind(this),
      viewdetail: this.viewdetail.bind(this),
      updatemodule: this.updatemodule.bind(this),
      updatestatus: this.updatestatus.bind(this)
    };
  }

  async deletenode() {
    // set the target node
    targetNode = this.getNode();

    // open the confirmation modal to delete the node
    self.$refs[`confirmation-delete`].open();
  }

  edittag() {
    const node = this.getNode();
    const editdetailbtn = document.querySelector('#editdetailbtn');
    editdetailbtn.setAttribute('data-moduleid', this.scope.moduleid);
    editdetailbtn.setAttribute('data-nodeid', node.id);
    editdetailbtn.setAttribute('data-nodename', node.name);
    editdetailbtn.click();
  }

  activateTagNode(e) {
    if (this.scope.isNodeConfigured) {
      let all;
      const node = this.getNode();
      if (node.name === 'Add Tag') {
        all = document.getElementsByClassName('add-tag');
      } else {
        all = document.getElementsByClassName('remove-tag');
      }
      if (e.target.checked) {
        if (all.length) {
          if (all[0]) all[0].style.background = '#fff';
          if (all[1]) all[1].style.background = '#fff';
        }
      } else if (all.length) {
        if (all[0]) all[0].style.background = '#f7f7fa';
        if (all[1]) all[1].style.background = '#f7f7fa';
      }
      const activatebtn = document.querySelector('#activatenodebtn');
      if (this.scope.moduleid) {
        activatebtn.setAttribute('data-moduleid', this.scope.moduleid);
      }
      activatebtn.setAttribute('data-nodeid', node.id);
      activatebtn.setAttribute('data-nodestatus', e.target.checked);
      activatebtn.click();
    } else {
      i18n.locale = localStorage.lang;
      showAlert({
        iconType: 'alert-error',
        html: `
          <style>.swal2-confirm { color: ${
            themeConfig.appPrimaryColorInvert
          } !important; }</style>
          <p class="text-sm text-deep-dark"> ${i18n.t(
            'frontend_groovemail_sequence_configure_tag_node'
          )}</p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: i18n.t('frontend_close')
      });
      const tagToggle = document.getElementById(`tagToggle-${this.scope.id}`);
      tagToggle.checked = false;
    }
  }

  viewdetail() {
    const node = this.getNode();
    const viewdetailbtn = document.querySelector('#viewdetailbtn');
    viewdetailbtn.setAttribute('data-node_id', node.id);
    viewdetailbtn.setAttribute('data-moduleid', this.scope.moduleid);
    viewdetailbtn.click();
  }

  updatemodule() {
    const node = this.getNode();
    this.scope.selectedtags = node.data.selectedtags = selectedtags;
    this.scope.status = node.data.status = nodestatus;
    this.scope.checked = nodestatus === 'Active' ? 'checked' : '';
    this.emitter.trigger('process');
    this._alight.scan();
  }

  updatestatus() {
    const node = this.getNode();
    this.scope.status = node.data.status = nodestatus;
    this.scope.checked = nodestatus === 'Active' ? 'checked' : '';
    this.emitter.trigger('process');
    this._alight.scan();
  }

  savetag() {
    const node = this.getNode();

    this.scope.selectedtags = node.data.selectedtags = selectedtags;
    this.scope.status = node.data.status = nodestatus;
    this.scope.moduleid = node.data.moduleid = newmoduleid;
    this.scope.checked = nodestatus === 'Active' ? 'checked' : '';
    this.update();

    this.emitter.trigger('process');
    this._alight.scan();
  }

  update() {
    if ((this.getNode(), this.getNode().data && this.getNode().data.moduleid)) {
      this.scope.isNodeConfigured = true;
    }
  }

  mounted() {
    this.scope.selectedtags = '';
    this.scope.id = this.getNode().id;
    if ((this.getNode(), this.getNode().data && this.getNode().data.moduleid)) {
      this.scope.isNodeConfigured = true;
    }

    if (this.getNode().data.selectedtags) {
      this.scope.selectedtags = this.getNode().data.selectedtags;
    }

    if (this.getNode().data.moduleid) {
      this.scope.moduleid = this.getNode().data.moduleid;
    }

    if (this.getNode().data.status) {
      this.scope.status = this.getNode().data.status;
      this.scope.checked =
        this.getNode().data.status === 'Active' ? 'checked' : '';
    }

    this.emitter.trigger('process');
    this._alight.scan();
  }
}

class AddTagComponent extends Rete.Component {
  constructor() {
    super('Add Tag');
    this.module = {
      nodeType: 'module'
    };
    this.render = 'vue';
    this.data.props = {};
  }

  builder(node) {
    const ctrl = new TagControl(
      this.editor,
      'module',
      false,
      'text',
      'Add Tag'
    );
    const indot = new Rete.Input('addtagInput', '', anyTypeSocket, false);
    const out = new Rete.Output('addtagOutput', '', anyTypeSocket, false);

    ctrl.onChange = () => {
      this.updateModuleSockets(node);
      node._alight.scan();
    };
    return node
      .addControl(ctrl)
      .addOutput(out)
      .addInput(indot);
  }
}

class RemoveTagComponent extends Rete.Component {
  constructor() {
    super('Remove Tag');
    this.module = {
      nodeType: 'module'
    };
    this.render = 'vue';
    this.data.props = {};
  }

  builder(node) {
    const ctrl = new TagControl(
      this.editor,
      'module',
      false,
      'text',
      'Remove Tag'
    );
    const indot = new Rete.Input('removetagInput', '', anyTypeSocket, false);
    const out = new Rete.Output('removetagOutput', '', anyTypeSocket, false);

    ctrl.onChange = () => {
      this.updateModuleSockets(node);
      node._alight.scan();
    };
    return node
      .addControl(ctrl)
      .addOutput(out)
      .addInput(indot);
  }
}

class ListControl extends Rete.Control {
  constructor(emitter, key, readonly, type = 'text', listNodeType) {
    super(key);
    this.emitter = emitter;
    this.key = key;
    this.type = type;
    this.props = {};
    this.keyz = 0;
    this.listNodeType = listNodeType;
    this.id = Math.random()
      .toString(36)
      .substr(2, 9);
    i18n.locale = localStorage.lang;
    this.template = `<div class="control-main-header"><span class="control-header-title text-grey-800" @click="editlist($event)" @dblclick.stop="" @pointerdown.stop="" @pointermove.stop="" title="Click to configure"> ${listNodeType}</span></div><button @click="savelist($event)" id="savelist{{id}}" class="savelist" style="display:none;">-</button><button @click="updatemodule($event)" id="updatemodule{{id}}" class="updatemodule" style="display:none;">-</button><button @click="updatestatus($event)" id="updatestatus{{id}}" class="updatestatus" style="display:none;">-</button>`;
    this.template += `<div class="dropdown mt-2 mr-4 pull-right"><button class="dropbtn"></button><div class="text-left dropdown-content"><a class="hover:text-primary" @click="editlist($event)">${i18n.t(
      'frontend_edit'
    )}</a><a class="hover:text-primary" @click="deletenode($event)" id="deletenode{{id}}">${i18n.t(
      'frontend_remove'
    )}</a></div></div><div class="outputDisplay text-sm "><p class="broadcast-header">{{selectedlists}}</p><input id="listToggle-{{id}}" type="checkbox" class="cm-toggle {{checked}}" @change="activateListNode($event)" :checked="checked" @dblclick.stop="" @pointerdown.stop="" @pointermove.stop=""/><span class="text-sm activeState">{{status}}</span></div>`;

    this.scope = {
      value: null,
      readonly,
      id: null,
      moduleid: '',
      status: '',
      checked: '',
      isNodeConfigured: false,
      selectedlists,
      savelist: this.savelist.bind(this),
      viewdetail: this.viewdetail.bind(this),
      activateListNode: this.activateListNode.bind(this),
      updatemodule: this.updatemodule.bind(this),
      editlist: this.editlist.bind(this),
      deletenode: this.deletenode.bind(this),
      updatestatus: this.updatestatus.bind(this)
    };
  }

  editlist() {
    const node = this.getNode();
    const editdetailbtn = document.querySelector('#editdetailbtn');
    editdetailbtn.setAttribute('data-moduleid', this.scope.moduleid);
    editdetailbtn.setAttribute('data-nodeid', node.id);
    editdetailbtn.setAttribute('data-nodename', node.name);
    editdetailbtn.click();
  }

  activateListNode(e) {
    if (this.scope.isNodeConfigured) {
      let all;
      const node = this.getNode();
      if (node.name === 'Subscribe To List') {
        all = document.getElementsByClassName('subscribe-to-list');
      } else {
        all = document.getElementsByClassName('unsubscribe-from-list');
      }
      if (e.target.checked) {
        if (all.length) {
          if (all[0]) all[0].style.background = '#fff';
          if (all[1]) all[1].style.background = '#fff';
        }
      } else if (all.length) {
        if (all[0]) all[0].style.background = '#f7f7fa';
        if (all[1]) all[1].style.background = '#f7f7fa';
      }
      const activatebtn = document.querySelector('#activatenodebtn');
      if (this.scope.moduleid) {
        activatebtn.setAttribute('data-moduleid', this.scope.moduleid);
      }
      activatebtn.setAttribute('data-nodeid', node.id);
      activatebtn.setAttribute('data-nodestatus', e.target.checked);
      activatebtn.click();
    } else {
      i18n.locale = localStorage.lang;
      showAlert({
        iconType: 'alert-error',
        html: `
          <style>.swal2-confirm { color: ${
            themeConfig.appPrimaryColorInvert
          } !important; }</style>
          <p class="text-sm text-deep-dark"> ${i18n.t(
            'frontend_groovemail_sequence_configure_list_node'
          )}</p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: i18n.t('frontend_close')
      });
      const listToggle = document.getElementById(`listToggle-${this.scope.id}`);
      listToggle.checked = false;
    }
  }

  async deletenode() {
    // set the target node
    targetNode = this.getNode();

    // open the confirmation modal to delete the node
    self.$refs[`confirmation-delete`].open();
  }

  updatemodule() {
    const node = this.getNode();
    this.scope.selectedlists = node.data.selectedlists = selectedlists;
    this.scope.listdelayoption = node.data.listdelayoption = listdelayoption;
    this.scope.listaction = node.data.listaction = listaction;
    this.scope.status = node.data.status = nodestatus;
    this.scope.checked = nodestatus === 'Active' ? 'checked' : '';
    this.emitter.trigger('process');
    this._alight.scan();
  }

  updatestatus() {
    const node = this.getNode();
    this.scope.status = node.data.status = nodestatus;
    this.scope.checked = nodestatus === 'Active' ? 'checked' : '';
    this.emitter.trigger('process');
    this._alight.scan();
  }

  viewdetail() {
    const node = this.getNode();
    const viewdetailbtn = document.querySelector('#viewdetailbtn');
    viewdetailbtn.setAttribute('data-node_id', node.id);
    viewdetailbtn.setAttribute('data-moduleid', this.scope.moduleid);
    viewdetailbtn.click();
  }

  savelist() {
    const node = this.getNode();

    this.scope.selectedlists = node.data.selectedlists = selectedlists;
    this.scope.moduleid = node.data.moduleid = newmoduleid;
    this.scope.status = node.data.status = nodestatus;
    this.scope.checked = nodestatus === 'Active' ? 'checked' : '';
    this.update();

    this.emitter.trigger('process');
    this._alight.scan();
  }

  update() {
    if ((this.getNode(), this.getNode().data && this.getNode().data.moduleid)) {
      this.scope.isNodeConfigured = true;
    }
  }

  mounted() {
    this.scope.selectedlists = '';
    this.scope.id = this.getNode().id;
    if ((this.getNode(), this.getNode().data && this.getNode().data.moduleid)) {
      this.scope.isNodeConfigured = true;
    }

    if (this.getNode().data.selectedlists) {
      this.scope.selectedlists = this.getNode().data.selectedlists;
    }

    if (this.getNode().data.moduleid) {
      this.scope.moduleid = this.getNode().data.moduleid;
    }

    if (this.getNode().data.status) {
      this.scope.status = this.getNode().data.status;
      this.scope.checked =
        this.getNode().data.status === 'Active' ? 'checked' : '';
    }

    this.emitter.trigger('process');
    this._alight.scan();
  }
}

class SubscribeListComponent extends Rete.Component {
  constructor() {
    super('Subscribe To List');
    this.module = {
      nodeType: 'module'
    };
    this.render = 'vue';
    this.data.props = {};
  }

  builder(node) {
    const ctrl = new ListControl(
      this.editor,
      'module',
      false,
      'text',
      'Subscribe To List'
    );
    const indot = new Rete.Input('listInput', '', anyTypeSocket, false);
    const out = new Rete.Output('listOutput', '', anyTypeSocket, false);

    ctrl.onChange = () => {
      this.updateModuleSockets(node);
      node._alight.scan();
    };
    return node
      .addControl(ctrl)
      .addOutput(out)
      .addInput(indot);
  }
}

class UnsubscribeListComponent extends Rete.Component {
  constructor() {
    super('Unsubscribe From List');
    this.module = {
      nodeType: 'module'
    };
    this.render = 'vue';
    this.data.props = {};
  }

  builder(node) {
    const ctrl = new ListControl(
      this.editor,
      'module',
      false,
      'text',
      'Unsubscribe From List'
    );
    const indot = new Rete.Input('removelistInput', '', anyTypeSocket, false);
    const out = new Rete.Output('removelistOutput', '', anyTypeSocket, false);

    ctrl.onChange = () => {
      this.updateModuleSockets(node);
      node._alight.scan();
    };
    return node
      .addControl(ctrl)
      .addOutput(out)
      .addInput(indot);
  }
}

class EmailControl extends Rete.Control {
  constructor(emitter, key, readonly, type = 'text') {
    super(key);
    this.emitter = emitter;
    this.key = key;
    this.type = type;
    this.props = {};
    this.keyz = 0;
    this.id = Math.random()
      .toString(36)
      .substr(2, 9);
    i18n.locale = localStorage.lang;
    this.template =
      '<div class="control-main-header"><span class="control-header-title text-grey-800" @click="editemail($event)" @dblclick.stop="" @pointerdown.stop="" @pointermove.stop="" title="Click to configure"> Send Email</span></div><button @click="saveemail($event)" id="saveemail{{id}}" class="savetag" style="display:none;">-</button><button @click="updatemodule($event)" id="updatemodule{{id}}" class="updatemodule" style="display:none;">-</button><button @click="updatestatus($event)" id="updatestatus{{id}}" class="updatestatus" style="display:none;">-</button>';

    this.template += `<div class="dropdown mt-2 mr-4 pull-right"><button class="dropbtn"></button><div class="text-left dropdown-content"><a class="hover:text-primary" @click="editemail($event)">${i18n.t(
      'frontend_edit'
    )}</a><a class="hover:text-primary" @click="deletenode($event)" id="deletenode{{id}}">${i18n.t(
      'frontend_remove'
    )}</a></div></div><div class="outputDisplay text-sm "><p class="broadcast-header">{{selectedemails}}</p><input id="emailToggle-{{id}}" type="checkbox" class="cm-toggle {{checked}}" @change="activateEmailNode($event)" :checked="checked" @dblclick.stop="" @pointerdown.stop="" @pointermove.stop=""/><span class="text-sm activeState">{{status}}</span></div>`;

    this.scope = {
      value: null,
      readonly,
      id: null,
      selectedemails: '',
      moduleid: '',
      status: '',
      checked: '',
      isNodeConfigured: false,
      saveemail: this.saveemail.bind(this),
      editemail: this.editemail.bind(this),
      deletenode: this.deletenode.bind(this),
      activateEmailNode: this.activateEmailNode.bind(this),
      viewdetail: this.viewdetail.bind(this),
      updatemodule: this.updatemodule.bind(this),
      updatestatus: this.updatestatus.bind(this)
    };
  }

  async deletenode() {
    // set the target node
    targetNode = this.getNode();

    // open the confirmation modal to delete the node
    self.$refs[`confirmation-delete`].open();
  }

  editemail() {
    const node = this.getNode();
    const editdetailbtn = document.querySelector('#editdetailbtn');
    editdetailbtn.setAttribute('data-moduleid', this.scope.moduleid);
    editdetailbtn.setAttribute('data-nodeid', node.id);
    editdetailbtn.setAttribute('data-nodename', node.name);
    editdetailbtn.click();
  }

  activateEmailNode(e) {
    if (this.scope.isNodeConfigured) {
      const all = document.getElementsByClassName('send-email');
      if (e.target.checked) {
        if (all.length) {
          if (all[0]) all[0].style.background = '#fff';
          if (all[1]) all[1].style.background = '#fff';
        }
      } else if (all.length) {
        if (all[0]) all[0].style.background = '#f7f7fa';
        if (all[1]) all[1].style.background = '#f7f7fa';
      }
      const node = this.getNode();
      const activatebtn = document.querySelector('#activatenodebtn');
      if (this.scope.moduleid) {
        activatebtn.setAttribute('data-moduleid', this.scope.moduleid);
      }
      activatebtn.setAttribute('data-nodeid', node.id);
      activatebtn.setAttribute('data-nodestatus', e.target.checked);
      activatebtn.click();
    } else {
      i18n.locale = localStorage.lang;
      showAlert({
        iconType: 'alert-error',
        html: `
          <style>.swal2-confirm { color: ${
            themeConfig.appPrimaryColorInvert
          } !important; }</style>
          <p class="text-sm text-deep-dark"> ${i18n.t(
            'frontend_groovemail_sequence_configure_email_node'
          )}</p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: i18n.t('frontend_close')
      });
      const emailToggle = document.getElementById(
        `emailToggle-${this.scope.id}`
      );
      emailToggle.checked = false;
    }
  }

  viewdetail() {
    const node = this.getNode();
    const viewdetailbtn = document.querySelector('#viewdetailbtn');
    viewdetailbtn.setAttribute('data-node_id', node.id);
    viewdetailbtn.setAttribute('data-moduleid', this.scope.moduleid);
    viewdetailbtn.click();
  }

  updatemodule() {
    const node = this.getNode();
    this.scope.selectedemails = node.data.selectedemails = selectedemails;
    this.scope.status = node.data.status = nodestatus;
    this.scope.checked = nodestatus === 'Active' ? 'checked' : '';
    this.emitter.trigger('process');
    this._alight.scan();
  }

  updatestatus() {
    const node = this.getNode();
    this.scope.status = node.data.status = nodestatus;
    this.scope.checked = nodestatus === 'Active' ? 'checked' : '';
    this.emitter.trigger('process');
    this._alight.scan();
  }

  saveemail() {
    const node = this.getNode();

    this.scope.selectedemails = node.data.selectedemails = selectedemails;
    this.scope.moduleid = node.data.moduleid = newmoduleid;
    this.scope.status = node.data.status = nodestatus;
    this.scope.checked = nodestatus === 'Active' ? 'checked' : '';
    this.update();

    this.emitter.trigger('process');
    this._alight.scan();
  }

  update() {
    if ((this.getNode(), this.getNode().data && this.getNode().data.moduleid)) {
      this.scope.isNodeConfigured = true;
    }
  }

  mounted() {
    this.scope.selectedemails = '';
    this.scope.id = this.getNode().id;
    if ((this.getNode(), this.getNode().data && this.getNode().data.moduleid)) {
      this.scope.isNodeConfigured = true;
    }

    if (this.getNode().data.selectedemails) {
      this.scope.selectedemails = this.getNode().data.selectedemails;
    }

    if (this.getNode().data.moduleid) {
      this.scope.moduleid = this.getNode().data.moduleid;
    }

    if (this.getNode().data.status) {
      this.scope.status = this.getNode().data.status;
      this.scope.checked =
        this.getNode().data.status === 'Active' ? 'checked' : '';
    }

    this.emitter.trigger('process');
    this._alight.scan();
  }
}

class EmailComponent extends Rete.Component {
  constructor() {
    super('Send Email');
    this.module = {
      nodeType: 'module'
    };
    this.render = 'vue';
    this.data.props = {};
  }

  builder(node) {
    const ctrl = new EmailControl(this.editor, 'module');
    const indot = new Rete.Input('emailInput', '', anyTypeSocket, false);
    const out = new Rete.Output('emailOutput', '', anyTypeSocket, false);

    ctrl.onChange = () => {
      this.updateModuleSockets(node);
      node._alight.scan();
    };
    return node
      .addControl(ctrl)
      .addOutput(out)
      .addInput(indot);
  }
}

class DelayControl extends Rete.Control {
  constructor(emitter, key, readonly, type = 'text') {
    super(key);
    this.emitter = emitter;
    this.key = key;
    this.type = type;
    this.props = {};
    this.keyz = 0;
    this.id = Math.random()
      .toString(36)
      .substr(2, 9);
    i18n.locale = localStorage.lang;

    this.template =
      '<div class="control-main-header"><span class="control-header-title text-grey-800" @click="editdelay($event)" @dblclick.stop="" @pointerdown.stop="" @pointermove.stop="" title="Click to configure"> Time Delay</span></div><button @click="savedelay($event)" id="savedelay{{id}}" class="savetag" style="display:none;">-</button><button @click="updatemodule($event)" id="updatemodule{{id}}" class="updatemodule" style="display:none;">-</button><button @click="updatestatus($event)" id="updatestatus{{id}}" class="updatestatus" style="display:none;">-</button>';

    this.template += `<div class="dropdown mt-2 mr-4 pull-right"><button class="dropbtn"></button><div class="text-left dropdown-content"><a class="hover:text-primary" @click="editdelay($event)">${i18n.t(
      'frontend_edit'
    )}</a><a class="hover:text-primary" @click="deletenode($event)" id="deletenode{{id}}">${i18n.t(
      'frontend_remove'
    )}</a></div></div><div class="outputDisplay text-sm "><p class="broadcast-header">{{selecteddelays}}</p><input id="delayToggle-{{id}}" type="checkbox" class="cm-toggle {{checked}}" @change="activateDelayNode($event)" :checked="checked" @dblclick.stop="" @pointerdown.stop="" @pointermove.stop=""/><span class="text-sm activeState">{{status}}</span></div>`;

    this.scope = {
      value: null,
      readonly,
      id: null,
      status: '',
      checked: '',
      selecteddelays: '',
      moduleid: '',
      isNodeConfigured: false,
      savedelay: this.savedelay.bind(this),
      editdelay: this.editdelay.bind(this),
      deletenode: this.deletenode.bind(this),
      activateDelayNode: this.activateDelayNode.bind(this),
      viewdetail: this.viewdetail.bind(this),
      updatemodule: this.updatemodule.bind(this),
      updatestatus: this.updatestatus.bind(this)
    };
  }

  async deletenode() {
    // set the target node
    targetNode = this.getNode();

    // open the confirmation modal to delete the node
    self.$refs[`confirmation-delete`].open();
  }

  editdelay() {
    const node = this.getNode();
    const editdetailbtn = document.querySelector('#editdetailbtn');
    editdetailbtn.setAttribute('data-moduleid', this.scope.moduleid);
    editdetailbtn.setAttribute('data-nodeid', node.id);
    editdetailbtn.setAttribute('data-nodename', node.name);
    editdetailbtn.click();
  }

  activateDelayNode(e) {
    if (this.scope.isNodeConfigured) {
      const all = document.getElementsByClassName('time-delay');
      if (e.target.checked) {
        if (all.length) {
          if (all[0]) all[0].style.background = '#fff';
          if (all[1]) all[1].style.background = '#fff';
        }
      } else if (all.length) {
        if (all[0]) all[0].style.background = '#f7f7fa';
        if (all[1]) all[1].style.background = '#f7f7fa';
      }
      const node = this.getNode();
      const activatebtn = document.querySelector('#activatenodebtn');
      if (this.scope.moduleid) {
        activatebtn.setAttribute('data-moduleid', this.scope.moduleid);
      }
      activatebtn.setAttribute('data-nodeid', node.id);
      activatebtn.setAttribute('data-nodestatus', e.target.checked);
      activatebtn.click();
    } else {
      i18n.locale = localStorage.lang;
      showAlert({
        iconType: 'alert-error',
        html: `
          <style>.swal2-confirm { color: ${
            themeConfig.appPrimaryColorInvert
          } !important; }</style>
          <p class="text-sm text-deep-dark"> ${i18n.t(
            'frontend_groovemail_sequence_configure_delay_node'
          )}</p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: i18n.t('frontend_close')
      });
      const delayToggle = document.getElementById(
        `delayToggle-${this.scope.id}`
      );
      delayToggle.checked = false;
    }
  }

  viewdetail() {
    const node = this.getNode();
    const viewdetailbtn = document.querySelector('#viewdetailbtn');
    viewdetailbtn.setAttribute('data-node_id', node.id);
    viewdetailbtn.setAttribute('data-moduleid', this.scope.moduleid);
    viewdetailbtn.click();
  }

  updatemodule() {
    const node = this.getNode();
    this.scope.selecteddelays = node.data.selecteddelays = selecteddelays;
    this.scope.status = node.data.status = nodestatus;
    this.scope.checked = nodestatus === 'Active' ? 'checked' : '';
    this.emitter.trigger('process');
    this._alight.scan();
  }

  updatestatus() {
    const node = this.getNode();
    this.scope.status = node.data.status = nodestatus;
    this.scope.checked = nodestatus === 'Active' ? 'checked' : '';
    this.emitter.trigger('process');
    this._alight.scan();
  }

  savedelay() {
    const node = this.getNode();

    this.scope.selecteddelays = node.data.selecteddelays = selecteddelays;
    this.scope.moduleid = node.data.moduleid = newmoduleid;
    this.scope.status = node.data.status = nodestatus;
    this.scope.checked = nodestatus === 'Active' ? 'checked' : '';
    this.update();

    this.emitter.trigger('process');
    this._alight.scan();
  }

  update() {
    if ((this.getNode(), this.getNode().data && this.getNode().data.moduleid)) {
      this.scope.isNodeConfigured = true;
    }
  }

  mounted() {
    this.scope.selecteddelays = '';
    this.scope.id = this.getNode().id;
    if ((this.getNode(), this.getNode().data && this.getNode().data.moduleid)) {
      this.scope.isNodeConfigured = true;
    }

    if (this.getNode().data.selecteddelays) {
      this.scope.selecteddelays = this.getNode().data.selecteddelays;
    }

    if (this.getNode().data.moduleid) {
      this.scope.moduleid = this.getNode().data.moduleid;
    }

    if (this.getNode().data.status) {
      this.scope.status = this.getNode().data.status;
      this.scope.checked =
        this.getNode().data.status === 'Active' ? 'checked' : '';
    }

    this.emitter.trigger('process');
    this._alight.scan();
  }
}

class DelayComponent extends Rete.Component {
  constructor() {
    super('Time Delay');
    this.module = {
      nodeType: 'module'
    };
    this.render = 'vue';
    this.data.props = {};
  }

  builder(node) {
    const ctrl = new DelayControl(this.editor, 'module');
    const indot = new Rete.Input('delayInput', '', anyTypeSocket, false);
    const out = new Rete.Output('delayOutput', '', anyTypeSocket, false);

    ctrl.onChange = () => {
      this.updateModuleSockets(node);
      node._alight.scan();
    };
    return node
      .addControl(ctrl)
      .addOutput(out)
      .addInput(indot);
  }
}

class SplitControl extends Rete.Control {
  constructor(emitter, key, readonly, type = 'text') {
    super(key);
    this.emitter = emitter;
    this.key = key;
    this.type = type;
    this.props = {};
    this.keyz = 0;
    this.id = Math.random()
      .toString(36)
      .substr(2, 9);
    i18n.locale = localStorage.lang;

    this.template =
      '<div class="control-main-header"><span class="control-header-title text-grey-800" @click="editsplit($event)" @dblclick.stop="" @pointerdown.stop="" @pointermove.stop="" title="Click to configure"> Conditional Split</span></div><button @click="savesplit($event)" id="savesplit{{id}}" class="savetag" style="display:none;">-</button><button @click="updatemodule($event)" id="updatemodule{{id}}" class="updatemodule" style="display:none;">-</button><button @click="updatestatus($event)" id="updatestatus{{id}}" class="updatestatus" style="display:none;">-</button>';

    this.template += `<div class="dropdown mt-2 mr-4 pull-right"><button class="dropbtn"></button><div class="text-left dropdown-content"><a class="hover:text-primary" @click="editsplit($event)">${i18n.t(
      'frontend_edit'
    )}</a><a class="hover:text-primary" @click="deletenode($event)" id="deletenode{{id}}">${i18n.t(
      'frontend_remove'
    )}</a></div></div><div class="outputDisplay output-wrapper text-sm "><div class="p-4"><p class="broadcast-header">Split</p><input id="splitToggle-{{id}}" type="checkbox" class="cm-toggle {{checked}}" @change="activateSplitNode($event)" :checked="checked" @dblclick.stop="" @pointerdown.stop="" @pointermove.stop=""/><span class="text-sm activeState">{{status}}</span></div><div class="conditional-decision flex"><button class="w-1/2 p-2 conditional-true-decision">False</button><button class="w-1/2 p-2 conditional-false-decision">True</button></div></div>`;

    this.scope = {
      value: null,
      readonly,
      id: null,
      status: '',
      checked: '',
      moduleid: '',
      isNodeConfigured: false,
      savesplit: this.savesplit.bind(this),
      editsplit: this.editsplit.bind(this),
      activateSplitNode: this.activateSplitNode.bind(this),
      deletenode: this.deletenode.bind(this),
      viewdetail: this.viewdetail.bind(this),
      updatemodule: this.updatemodule.bind(this),
      updatestatus: this.updatestatus.bind(this)
    };
  }

  async deletenode() {
    // set the target node
    targetNode = this.getNode();

    // open the confirmation modal to delete the node
    self.$refs[`confirmation-delete`].open();
  }

  editsplit() {
    const node = this.getNode();
    const editdetailbtn = document.querySelector('#editdetailbtn');
    editdetailbtn.setAttribute('data-moduleid', this.scope.moduleid);
    editdetailbtn.setAttribute('data-nodeid', node.id);
    editdetailbtn.setAttribute('data-nodename', node.name);
    editdetailbtn.click();
  }

  updatestatus() {
    const node = this.getNode();
    this.scope.status = node.data.status = nodestatus;
    this.scope.checked = nodestatus === 'Active' ? 'checked' : '';
    this.emitter.trigger('process');
    this._alight.scan();
  }

  activateSplitNode(e) {
    if (this.scope.isNodeConfigured) {
      const all = document.getElementsByClassName('conditional-split');
      if (e.target.checked) {
        if (all.length) {
          if (all[0]) all[0].style.background = '#fff';
          if (all[1]) all[1].style.background = '#fff';
        }
      } else if (all.length) {
        if (all[0]) all[0].style.background = '#f7f7fa';
        if (all[1]) all[1].style.background = '#f7f7fa';
      }
      const node = this.getNode();
      const activatebtn = document.querySelector('#activatenodebtn');
      if (this.scope.moduleid) {
        activatebtn.setAttribute('data-moduleid', this.scope.moduleid);
      }
      activatebtn.setAttribute('data-nodeid', node.id);
      activatebtn.setAttribute('data-nodestatus', e.target.checked);
      activatebtn.click();
    } else {
      i18n.locale = localStorage.lang;
      showAlert({
        iconType: 'alert-error',
        html: `
          <style>.swal2-confirm { color: ${
            themeConfig.appPrimaryColorInvert
          } !important; }</style>
          <p class="text-sm text-deep-dark"> ${i18n.t(
            'frontend_groovemail_sequence_configure_split_node'
          )}</p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: i18n.t('frontend_close')
      });
      const splitToggle = document.getElementById(
        `splitToggle-${this.scope.id}`
      );
      splitToggle.checked = false;
    }
  }

  viewdetail() {
    const node = this.getNode();
    const viewdetailbtn = document.querySelector('#viewdetailbtn');
    viewdetailbtn.setAttribute('data-node_id', node.id);
    viewdetailbtn.setAttribute('data-moduleid', this.scope.moduleid);
    viewdetailbtn.click();
  }

  updatemodule() {
    const node = this.getNode();
    this.scope.status = node.data.status = nodestatus;
    this.scope.checked = nodestatus === 'Active' ? 'checked' : '';
    this.emitter.trigger('process');
    this._alight.scan();
  }

  savesplit() {
    const node = this.getNode();
    this.scope.moduleid = node.data.moduleid = newmoduleid;
    this.scope.status = node.data.status = nodestatus;
    this.scope.checked = nodestatus === 'Active' ? 'checked' : '';
    this.update();

    this.emitter.trigger('process');
    this._alight.scan();
  }

  update() {
    if ((this.getNode(), this.getNode().data && this.getNode().data.moduleid)) {
      this.scope.isNodeConfigured = true;
    }
  }

  mounted() {
    this.scope.id = this.getNode().id;
    if ((this.getNode(), this.getNode().data && this.getNode().data.moduleid)) {
      this.scope.isNodeConfigured = true;
    }

    if (this.getNode().data.moduleid) {
      this.scope.moduleid = this.getNode().data.moduleid;
    }

    if (this.getNode().data.status) {
      this.scope.status = this.getNode().data.status;
      this.scope.checked =
        this.getNode().data.status === 'Active' ? 'checked' : '';
    }

    this.emitter.trigger('process');
    this._alight.scan();
  }
}

class ConditionalSplitComponent extends Rete.Component {
  constructor() {
    super('Conditional Split');
    this.module = {
      nodeType: 'module'
    };
    this.render = 'vue';
    this.data.props = {};
    this.task = {
      outputs: { then: 'option', else: 'option' }
    };
  }

  builder(node) {
    node
      .addControl(new SplitControl(this.editor, 'module'))
      .addInput(new Rete.Input('splitInput', '', anyTypeSocket))
      .addOutput(new Rete.Output('splitfalseOutput', '', anyTypeSocket))
      .addOutput(new Rete.Output('splittrueOutput', '', anyTypeSocket));
  }
}

class EndComponent extends Rete.Component {
  constructor() {
    super('End Of Sequence');
    this.module = {
      nodeType: 'module'
    };
    this.render = 'vue';
    this.data.props = {};
  }

  builder(node) {
    const ctrl = new EndControl(this.editor, 'module');
    const indot = new Rete.Input('endInput', '', anyTypeSocket, false);

    ctrl.onChange = () => {
      this.updateModuleSockets(node);
      node._alight.scan();
    };

    return node.addControl(ctrl).addInput(indot);
  }

  change() {
    this.editor.trigger('process');
    this.getNode()._alight.scan();
  }
}

class EndControl extends Rete.Control {
  constructor(emitter, key, readonly, type = 'text') {
    super(key);
    this.emitter = emitter;
    this.key = key;
    this.type = type;
    this.keyz = 0;
    this.props = {};
    this.template = '';
    i18n.locale = localStorage.lang;

    this.template += `<div class="control-main-header rounded bg-primary-dark"><span class="control-header-title text-primary-invert">${i18n.t(
      'frontend_groovemail_sequences_end_of_a_sequence_node_content'
    )}</span>
      <button @click="saveend($event)" id="saveend{{id}}" class="saveend" style="display:none;">-</button>
      <div class="dropdown dropdown-end pull-right"><button class="dropbtn"></button><div class="text-left dropdown-content"><a class="hover:text-primary" @click="deletenode($event)" id="deletenode{{id}}">${i18n.t(
        'frontend_remove'
      )}</a></div>
      </div></div>`;

    this.scope = {
      value: null,
      readonly,
      id: null,
      moduleid: '',
      status: 1,
      isNodeConfigured: false,
      saveend: this.saveend.bind(this),
      deletenode: this.deletenode.bind(this)
    };
  }

  saveend() {
    const node = this.getNode();
    this.scope.moduleid = node.data.moduleid = newmoduleid;
    // this.scope.status = node.data.status = 1;
    this.update();

    this.emitter.trigger('process');
    this._alight.scan();
  }

  async deletenode() {
    // set the target node
    targetNode = this.getNode();

    // open the confirmation modal to delete the node
    self.$refs[`confirmation-delete`].open();
  }

  update() {
    // this.putData(this.emitter, this.key, newstartrule);
    this.emitter.trigger('process');
    this._alight.scan();
  }

  mounted() {
    this.scope.id = this.getNode().id;
    if ((this.getNode(), this.getNode().data && this.getNode().data.moduleid)) {
      this.scope.isNodeConfigured = true;
    }

    if (this.getNode().data.moduleid) {
      this.scope.moduleid = this.getNode().data.moduleid;
    }

    if (this.getNode().data.status) {
      this.scope.status = this.getNode().data.status;
    }

    this.emitter.trigger('process');
    this._alight.scan();
  }
}

class PostalControl extends Rete.Control {
  constructor(emitter, key, readonly, type = 'text') {
    super(key);
    this.emitter = emitter;
    this.key = key;
    this.type = type;
    this.props = {};
    this.keyz = 0;
    this.id = Math.random()
      .toString(36)
      .substr(2, 9);
    i18n.locale = localStorage.lang;
    this.template =
      '<div class="control-main-header"><span class="control-header-title text-grey-800" @click="editPostal($event)" @dblclick.stop="" @pointerdown.stop="" @pointermove.stop="" title="Click to configure"> Send Postcards</span></div><button @click="savePostal($event)" id="savepostal{{id}}" class="savetag" style="display:none;">-</button><button @click="updatemodule($event)" id="updatemodule{{id}}" class="updatemodule" style="display:none;">-</button><button @click="updatestatus($event)" id="updatestatus{{id}}" class="updatestatus" style="display:none;">-</button>';

    this.template += `<div class="dropdown mt-2 mr-4 pull-right"><button class="dropbtn"></button><div class="text-left dropdown-content"><a class="hover:text-primary" @click="editPostal($event)">${i18n.t(
      'frontend_edit'
    )}</a><a class="hover:text-primary" @click="deletenode($event)" id="deletenode{{id}}">${i18n.t(
      'frontend_remove'
    )}</a></div></div><div class="outputDisplay text-sm "><p class="broadcast-header">{{selectedPostalCampaign}}</p><input id="postalToggle-{{id}}" type="checkbox" class="cm-toggle {{checked}}" @change="activatePostalNode($event)" :checked="checked" @dblclick.stop="" @pointerdown.stop="" @pointermove.stop=""/><span class="text-sm activeState">{{status}}</span></div>`;

    this.scope = {
      value: null,
      readonly,
      id: null,
      selectedPostalCampaign: '',
      moduleid: '',
      status: '',
      checked: '',
      isNodeConfigured: false,
      savePostal: this.savePostal.bind(this),
      editPostal: this.editPostal.bind(this),
      deletenode: this.deletenode.bind(this),
      activatePostalNode: this.activatePostalNode.bind(this),
      viewdetail: this.viewdetail.bind(this),
      updatemodule: this.updatemodule.bind(this),
      updatestatus: this.updatestatus.bind(this)
    };
  }

  async deletenode() {
    // set the target node
    targetNode = this.getNode();

    // open the confirmation modal to delete the node
    self.$refs[`confirmation-delete`].open();
  }

  editPostal() {
    const node = this.getNode();
    const editdetailbtn = document.querySelector('#editdetailbtn');
    editdetailbtn.setAttribute('data-moduleid', this.scope.moduleid);
    editdetailbtn.setAttribute('data-nodeid', node.id);
    editdetailbtn.setAttribute('data-nodename', node.name);
    editdetailbtn.click();
  }

  activatePostalNode(e) {
    if (this.scope.isNodeConfigured) {
      const all = document.getElementsByClassName('send-postcards');
      if (e.target.checked) {
        if (all.length) {
          if (all[0]) all[0].style.background = '#fff';
          if (all[1]) all[1].style.background = '#fff';
        }
      } else if (all.length) {
        if (all[0]) all[0].style.background = '#f7f7fa';
        if (all[1]) all[1].style.background = '#f7f7fa';
      }
      const node = this.getNode();
      const activatebtn = document.querySelector('#activatenodebtn');
      if (this.scope.moduleid) {
        activatebtn.setAttribute('data-moduleid', this.scope.moduleid);
      }
      activatebtn.setAttribute('data-nodeid', node.id);
      activatebtn.setAttribute('data-nodestatus', e.target.checked);
      activatebtn.click();
    } else {
      i18n.locale = localStorage.lang;
      showAlert({
        iconType: 'alert-error',
        html: `
          <style>.swal2-confirm { color: ${
            themeConfig.appPrimaryColorInvert
          } !important; }</style>
          <p class="text-sm text-deep-dark"> ${i18n.t(
            'frontend_groovemail_sequence_configure_postal_node'
          )}</p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: i18n.t('frontend_close')
      });
      const emailToggle = document.getElementById(
        `postalToggle-${this.scope.id}`
      );
      emailToggle.checked = false;
    }
  }

  viewdetail() {
    const node = this.getNode();
    const viewdetailbtn = document.querySelector('#viewdetailbtn');
    viewdetailbtn.setAttribute('data-node_id', node.id);
    viewdetailbtn.setAttribute('data-moduleid', this.scope.moduleid);
    viewdetailbtn.click();
  }

  updatemodule() {
    const node = this.getNode();
    this.scope.selectedPostalCampaign = node.data.selectedPostalCampaign = selectedPostalCampaign;
    this.scope.status = node.data.status = nodestatus;
    this.scope.checked = nodestatus === 'Active' ? 'checked' : '';
    this.emitter.trigger('process');
    this._alight.scan();
  }

  updatestatus() {
    const node = this.getNode();
    this.scope.status = node.data.status = nodestatus;
    this.scope.checked = nodestatus === 'Active' ? 'checked' : '';
    this.emitter.trigger('process');
    this._alight.scan();
  }

  savePostal() {
    const node = this.getNode();

    this.scope.selectedPostalCampaign = node.data.selectedPostalCampaign = selectedPostalCampaign;
    this.scope.moduleid = node.data.moduleid = newmoduleid;
    this.scope.status = node.data.status = nodestatus;
    this.scope.checked = nodestatus === 'Active' ? 'checked' : '';
    this.update();

    this.emitter.trigger('process');
    this._alight.scan();
  }

  update() {
    if ((this.getNode(), this.getNode().data && this.getNode().data.moduleid)) {
      this.scope.isNodeConfigured = true;
    }
  }

  mounted() {
    this.scope.selectedPostalCampaign = '';
    this.scope.id = this.getNode().id;
    if ((this.getNode(), this.getNode().data && this.getNode().data.moduleid)) {
      this.scope.isNodeConfigured = true;
    }

    if (this.getNode().data.selectedPostalCampaign) {
      this.scope.selectedPostalCampaign = this.getNode().data.selectedPostalCampaign;
    }

    if (this.getNode().data.moduleid) {
      this.scope.moduleid = this.getNode().data.moduleid;
    }

    if (this.getNode().data.status) {
      this.scope.status = this.getNode().data.status;
      this.scope.checked =
        this.getNode().data.status === 'Active' ? 'checked' : '';
    }

    this.emitter.trigger('process');
    this._alight.scan();
  }
}

class PostalComponent extends Rete.Component {
  constructor() {
    super('Send Postcards');
    this.module = {
      nodeType: 'module'
    };
    this.render = 'vue';
    this.data.props = {};
  }

  builder(node) {
    const ctrl = new PostalControl(this.editor, 'module');
    const indot = new Rete.Input('postalInput', '', anyTypeSocket, false);
    const out = new Rete.Output('postalOutput', '', anyTypeSocket, false);

    ctrl.onChange = () => {
      this.updateModuleSockets(node);
      node._alight.scan();
    };
    return node
      .addControl(ctrl)
      .addOutput(out)
      .addInput(indot);
  }
}
</script>

<style lang="scss">
html,
body {
  margin: 0;
  height: 100%;
}

#rete {
  height: 100% !important;
  width: 100% !important;
}

#modules {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 5;
}

.module-list {
  padding: 5px;
  cursor: pointer;
}

.module:hover {
  color: #a167e7;
}

.horizontal .triggers {
  border: 0 !important;
  background-color: white !important;
  /* min-height: 180px; */
  min-width: 100px;
}

.vertical {
  .triggers {
    border: none;
    background-color: #fff;
    -webkit-box-shadow: 20px 20px 40px 0 rgba(22, 29, 37, 0.05);
    -moz-box-shadow: 20px 20px 40px 0 rgba(22, 29, 37, 0.05);
    box-shadow: 20px 20px 40px 0 rgba(22, 29, 37, 0.05);
    border-radius: 6px;

    .dropdown {
      .moduleicon {
        width: 24px;
        height: 24px;
        display: block;
        margin: 0 auto;
      }
    }

    .control {
      padding: 20px 15px 16px !important;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }

  &.node-editor .triggers {
    width: 348px;
    padding-bottom: 0;
    /* height: 183px; */
  }
}

.vertical,
.horizontal {
  .triggers .dropdown {
    .tag-icon {
      background: url('../../assets/images/icons/sequences/tag.png');
    }

    .list-icon {
      background: url('../../assets/images/icons/sequences/list.png');
    }

    .form-icon {
      background: url('../../assets/images/icons/sequences/form.png');
    }
  }
}

.startmodule {
  &:focus,
  &:hover {
    outline: none;
  }
}

.control {
  text-align: center;
}

.dropdown {
  position: relative;
  top: 5px;
  right: 0;
  color: #d5d8e5;

  &-end {
    position: relative;
    top: 0px !important;
    right: 0;
    color: #d5d8e5;
  }

  .dropbtn {
    width: 24px;
    height: 24px;
    background-image: url('../../assets/images/icons/sequences/dropdown.png');
  }

  &-content {
    display: none;
    position: absolute;
    min-width: 100px;
    background: #fff;
    box-shadow: 20px 20px 40px 0 rgba(22, 29, 37, 0.05);
    border-radius: 6px;
    z-index: 1;
    padding: 8px 0;

    a {
      padding: 8px 16px;
      font-size: 14px;
      font-weight: 600;
      color: #545671;
      text-decoration: none;
      display: block;
    }
  }

  &:hover {
    .dropdown-content {
      display: block;
    }
  }
}

.modulecount {
  line-height: 16px;
  display: block;
  position: absolute;
  top: -7px;
  right: -7px;
}

.dock {
  position: fixed;
  height: calc(100vh - 4rem);
  width: 240px;
  white-space: nowrap;
  overflow: auto;
  z-index: 7;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }

  &-item {
    display: inline-block;
    vertical-align: top;
    transform: scale(0.8);
    transform-origin: 50% 0;
  }
}

.mail-container {
  flex: 1;
  overflow: hidden;
}

.item .node {
  /* right side tile icons settings */
  .node-title {
    position: relative;
  }
}

.item .node .node-title:before,
.node .title:before {
  content: '';
  width: 16px;
  height: 16px;
  position: absolute;
  top: 50%;

  left: 10px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  transform: translate(5px, -8px);
}

.editor {
  max-height: calc(100vh - 80px) !important;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  height: 100vh;

  .tag .title,
  .list .title {
    display: none;
  }

  .node {
    .control {
      position: relative;

      &:before {
        width: 24px;
        height: 24px;
        display: inline-block;
        content: '';
        position: absolute;
        left: 10px;
        top: 12px;
      }

      .control-main-header {
        text-align: left;
        padding: 12px;
      }

      .control-header-title {
        font-size: 14px;
        font-weight: 700;
        padding-left: 30px;
      }
    }

    &.triggers .control:before {
      background-image: url('../../assets/images/icons/sequences/editor-trigger.png');
    }

    &.send-email .control:before {
      background-image: url('../../assets/images/icons/sequences/editor-send-email.png');
    }

    &.send-postcards .control:before {
      background-image: url('../../assets/images/icons/sequences/editor-send-email.png');
    }

    &.send-sms .control:before {
      background-image: url('../../assets/images/icons/sequences/editor-send-sms.png');
    }

    &.add-tag .control:before {
      background-image: url('../../assets/images/icons/sequences/editor-add-tag.png');
    }

    &.remove-tag .control:before {
      background-image: url('../../assets/images/icons/sequences/editor-remove-tag.png');
    }

    &.subscribe-to-list .control:before {
      background-image: url('../../assets/images/icons/sequences/editor-subscribe-list.png');
    }

    &.unsubscribe-from-list .control:before {
      background-image: url('../../assets/images/icons/sequences/editor-unsubscribe-list.png');
    }

    &.time-delay .control:before {
      background-image: url('../../assets/images/icons/sequences/editor-time-delay.png');
    }

    &.conditional-split .control:before {
      background-image: url('../../assets/images/icons/sequences/editor-conditional-split.png');
    }

    &.goto .control:before {
      background-image: url('../../assets/images/icons/sequences/editor-go-to.png');
    }

    &.end-of-sequence {
      .control {
        &:before {
          background-image: url('../../assets/images/icons/sequences/Go-To-Icon.png');
          background-repeat: no-repeat;
          background-size: 20px;
          margin-top: 2px;
        }

        &-header-title {
          font-size: 16px;
          font-weight: 700;
          padding-left: 30px;
        }
      }
    }

    &.triggers {
      .control {
        padding: 0px !important;

        &-main-header {
          text-align: left;
          padding: 12px;
        }
      }
    }
  }
}

.item {
  .output,
  .input {
    display: none;
  }

  .node.time-delay,
  .node.conditional-split,
  .node.send-email {
    margin-top: 45px;
    position: relative;
  }

  .node.send-email .timing-header,
  .node.time-delay .timing-header,
  .conditional-split .logic-header {
    position: absolute;
    margin-top: -29px;
    font-size: 0.875rem;
  }

  .node.send-email .node-title,
  .node.time-delay .node-title,
  .conditional-split .node-title {
    font-family: sans-serif;
    font-size: 14px;
    padding: 10px 8px 9px 46px !important;
  }

  .node {
    &.send-email .node-title:before {
      background-image: url('../../assets/images/icons/sequences/Send-Email.png');
    }

    &.send-postcards .title:before {
      background-image: url('../../assets/images/icons/sequences/Send-Email.png');
    }

    &.send-sms .title:before {
      background: url('../../assets/images/icons/sequences/Send-SMS.png');
    }

    &.add-tag .title:before {
      background-image: url('../../assets/images/icons/sequences/Add-Tag.png');
    }

    &.remove-tag .title:before {
      background-image: url('../../assets/images/icons/sequences/Remove-Tag.png');
    }

    &.subscribe-to-list .title:before {
      background-image: url('../../assets/images/icons/sequences/Subscribe-to-list.png');
    }

    &.unsubscribe-from-list .title:before {
      background-image: url('../../assets/images/icons/sequences/Unsubscribe-From-List-Icon.png');
    }

    &.time-delay .node-title:before {
      background-image: url('../../assets/images/icons/sequences/Delay-Icon.png');
    }

    &.conditional-split .node-title:before {
      background-image: url('../../assets/images/icons/sequences/Conditional-Split-Icon.png');
    }

    &.goto .title:before {
      background-image: url('../../assets/images/icons/sequences/Go-To-Icon.png');
    }

    &.end-of-sequence .title:before {
      background-image: url('../../assets/images/icons/sequences/Go-To-Icon.png');
    }
  }
}

.custommodel
  .bg-white.rounded-lg.shadow-2xl.relative.flex.flex-col.overflow-hidden {
  width: 65% !important;
  min-height: 400px;
}

.tagmoduleicon {
  height: 30px !important;
  width: 30px !important;
  background-color: #fff;
  border-radius: 50%;
  padding: 10px;
}

.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: 0.3s ease;
  background-color: #c7c7c7;
}

.sequences-section-icon {
  color: white;
  font-size: 40px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

.modulecontainer {
  position: relative;

  &:hover .overlay {
    opacity: 1;
  }
}

#dock .triggers {
  display: none;
}

.vertical .connection.socket-input-any-type .main-path {
  stroke: var(--brand-primary);
  stroke-width: 2px;
  transform: translateX(-6.7px);
}

.horizontal {
  .connection.socket-input-any-type .main-path {
    stroke: var(--brand-primary);
    stroke-width: 2px;
    transform: translateY(6.3px);
  }

  .node {
    .output {
      height: 0;
    }

    &.end-of-sequence {
      &,
      &:hover,
      &:focus,
      &:active {
        border-radius: 4px;
      }
    }
  }

  .conditional-split .input {
    display: none;
  }

  &-btn {
    left: 287px;
    border-radius: 0px 4px 4px 0px !important;
    border-left: 0;
  }

  &-layout-icon {
    transform: rotateZ(-90deg);
  }
}

.connection.socket-input-any-type .marker {
  stroke: var(--brand-primary);
  fill: var(--brand-primary);
}

.configuration-tab {
  height: 100%;
  width: 100%;
  top: 0;
  z-index: 8;
  overflow: hidden;

  &-hidden {
    height: 0%;
    width: 0%;
    top: 0;
    z-index: 8;
    overflow: hidden;
  }
}

.vertical,
.horizontal {
  &-btn {
    bottom: 10px;
    border: 1px solid #d5d8e5 !important;
  }

  .node {
    /* trigger designs */
    &.triggers .input {
      display: none;
    }

    /* node design */
    .output-title,
    .input-title {
      display: none;
    }

    .control {
      padding: 0;
    }

    .title {
      display: none;
    }

    &,
    &:hover,
    &:focus,
    &:active {
      width: 348px;
      background: #fff;
      border: none;
      box-shadow: 20px 20px 40px 0 rgba(22, 29, 37, 0.05);
      padding-bottom: 0;
    }

    .output-title,
    .input-title {
      font-size: 14px;
      font-weight: 700;
      padding: 17px 5px 17px 48px !important;
      color: #191d3a;
      position: relative;
    }

    &.conditional-split {
      position: relative;
      padding: 0px;

      .output-title {
        position: relative;
      }

      // style for conditional split
      > .output {
        &:nth-child(2),
        &:nth-child(3) {
          .output.socket {
            position: absolute;
            bottom: -30px !important;
            margin: 0;
            left: 78px !important;
          }
        }

        &:nth-child(3) .output.socket {
          right: 70px !important;
          left: auto !important;
        }
      }
    }
  }
}

.node {
  &.selected {
    background: #ffffff !important;
  }

  .title {
    font-size: 14px !important;
    position: relative;
    padding: 10px 8px 9px 46px !important;
  }

  .socket {
    &.output {
      width: 15px !important;
      height: 15px !important;
      background: var(--brand-primary);
      position: absolute;
      top: auto !important;
      left: 50% !important;
      transform: translate(-50%, 0);
      bottom: -30px !important;
      margin: 0;
    }

    &.input {
      width: 15px !important;
      height: 15px !important;
      background: var(--brand-primary);
      position: absolute;
      bottom: auto !important;
      margin: 0;
      z-index: -1;
      left: 53.2% !important;
      top: -23px;
      transform: translate(-50%, 0);
    }

    &:hover {
      border-width: 1px !important;
    }
  }

  .output-title {
    display: none;
  }
}

.conditional-decision {
  border-top: 2px solid #d5d8e5;
}

.conditional-true-decisionm .conditional-false-decision {
  border: 0;
}

.conditional-true-decision {
  border-right: 2px solid #d5d8e5;
}

.delay-output-wrapper {
  display: none;
}

.outputDisplay {
  border-top: 1px solid #d5d8e5;
  padding: 20px 16px;
  text-align: left;
}

.output-wrapper {
  padding: 0px;
}

/* Toggle Button */
.cm-toggle {
  -webkit-appearance: none;
  -webkit-tap-highlight-color: transparent;
  position: relative;
  border: 0 !important;
  outline: 0;
  cursor: pointer;
  width: max-content !important;
  padding: 0px !important;
  background: transparent !important;

  /* To create surface of toggle button */
  &:after {
    content: '';
    width: 48px;
    height: 22px;
    display: inline-block;
    background: rgba(196, 195, 195, 0.55);
    border-radius: 18px;
    clear: both;
  }

  /* Contents before checkbox to create toggle handle */
  &:before {
    content: '';
    width: 18px;
    height: 18px;
    display: block;
    position: absolute;
    left: 2px;
    top: 1.4px;
    border-radius: 50%;
    background: rgb(255, 255, 255);
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.6);
  }

  /* Shift the handle to left on check event */
  &:checked:before {
    left: 28px;
    box-shadow: -1px 1px 3px rgba(0, 0, 0, 0.6);
  }

  /* Background color when toggle button will be active */
  &.checked:checked:after {
    background: var(--brand-primary-dark);
  }

  /* Transition for smoothness */
  &,
  &:before,
  &:after,
  &:checked:before,
  &:checked:after {
    transition: ease 0.3s;
    -webkit-transition: ease 0.3s;
    -moz-transition: ease 0.3s;
    -o-transition: ease 0.3s;
  }
}

.broadcast-header {
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #191d3a;
  margin-bottom: 10px;

  &:empty {
    margin-bottom: 0;
  }
}

.emailContainer {
  height: fit-content;
}

.variables {
  direction: ltr !important;
}

.vue-portal-target {
  display: flex;
}

.activeState {
  display: inline-block;
  vertical-align: top;
  margin-left: 10px;
}

.zoom-in-btn,
.zoom-in-btn-editor,
.zoom-out-btn,
.zoom-out-btn-editor {
  border: 1px solid #d5d8e5 !important;
}

.zoom-in-btn,
.zoom-in-btn-editor {
  border-radius: 4px 4px 0px 0px !important;
}

.zoom-out-btn,
.zoom-out-btn-editor {
  border-radius: 0px 0px 4px 4px !important;
}

.zoom-in-btn-editor {
  right: 14px;
  bottom: 43px;
}

.zoom-out-btn-editor {
  right: 10px;
  bottom: 12px;
}

.vertical-btn {
  left: 255px;
  border-radius: 4px 0px 0px 4px !important;
}

.header-btn {
  border-radius: 6px;
}
</style>
